import React, { FC, SVGProps } from 'react'
import { IconProps } from './index'

export const DetailPageIcon: FC<IconProps> = (props) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5756 1.43464C19.3444 1.19222 18.989 1.11489 18.678 1.23938C18.3671 1.36387 18.1632 1.66511 18.1632 2.00007V5.69977C17.8084 5.54262 17.4158 5.4557 17.0064 5.4557C15.4931 5.4557 14.2108 6.64311 14.2108 8.17508C14.2108 9.70705 15.4931 10.8945 17.0064 10.8945C18.5197 10.8945 19.8021 9.70705 19.8021 8.17508C19.8021 8.07109 19.7962 7.96869 19.7847 7.86815C19.796 7.8139 19.8019 7.75768 19.8019 7.70007V4.04682L20.3658 4.63822C20.6781 4.96573 21.1967 4.97809 21.5242 4.66581C21.8518 4.35354 21.8641 3.83489 21.5518 3.50737L19.5756 1.43464ZM15.8495 8.17508C15.8495 7.60836 16.3368 7.09445 17.0064 7.09445C17.676 7.09445 18.1633 7.60836 18.1633 8.17508C18.1633 8.74179 17.676 9.2557 17.0064 9.2557C16.3368 9.2557 15.8495 8.74179 15.8495 8.17508Z"
      fill="currentColor"
    />
    <path
      d="M11.5714 6.75006H11.0774H8.9604C7.28024 6.75006 6.44016 6.75006 5.79843 7.07704C5.23394 7.36466 4.775 7.8236 4.48738 8.38809C4.1604 9.02982 4.1604 9.8699 4.1604 11.5501V16.2001C4.1604 17.8802 4.1604 18.7203 4.48738 19.362C4.775 19.9265 5.23394 20.3855 5.79843 20.6731C6.44016 21.0001 7.28024 21.0001 8.9604 21.0001H13.1943C14.8745 21.0001 15.7146 21.0001 16.3563 20.6731C16.9208 20.3855 17.3797 19.9265 17.6674 19.362C17.9943 18.7203 17.9943 17.8802 17.9943 16.2001V13.3661"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.11292 16.25H14.0417"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.11292 12.4501H12.0655"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ReplayIcon: FC<IconProps> = (props) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.54167 10.0001C1.54167 5.05386 5.52387 1.04175 10.5 1.04175C13.4633 1.04175 15.6833 2.27907 17.1501 3.50142C17.5602 3.84312 17.9128 4.18473 18.2083 4.49989V2.12971C18.2083 1.78453 18.4882 1.50471 18.8333 1.50471C19.1785 1.50471 19.4583 1.78453 19.4583 2.12971V6.29638C19.4583 6.5773 19.2709 6.82371 19.0002 6.8987C18.7297 6.97362 18.4425 6.85904 18.2978 6.61861C18.2978 6.61852 18.2977 6.61844 18.2977 6.61835L18.2976 6.61831L18.2974 6.61794L18.2939 6.61219C18.29 6.60598 18.2835 6.59559 18.2744 6.58129C18.2561 6.55269 18.2272 6.50848 18.1877 6.4509C18.1087 6.33568 17.9876 6.1673 17.8245 5.96343C17.4977 5.55503 17.0057 5.00824 16.3499 4.4617C15.0389 3.36924 13.0923 2.29175 10.5 2.29175C6.21689 2.29175 2.79167 5.74155 2.79167 10.0001C2.79167 14.2573 6.24281 17.7084 10.5 17.7084C14.7572 17.7084 18.2083 14.2573 18.2083 10.0001C18.2083 9.6549 18.4882 9.37508 18.8333 9.37508C19.1785 9.37508 19.4583 9.6549 19.4583 10.0001C19.4583 14.9476 15.4476 18.9584 10.5 18.9584C5.55245 18.9584 1.54167 14.9476 1.54167 10.0001Z"
        fill="currentColor"
      />
      <path
        d="M8.83333 11.8386V8.16156C8.83333 7.67598 8.83333 7.43319 8.93457 7.29935C9.02278 7.18276 9.15759 7.11061 9.30353 7.1019C9.47105 7.09189 9.67306 7.22657 10.0771 7.49592L12.8349 9.33444C13.1687 9.557 13.3356 9.66828 13.3938 9.80855C13.4447 9.93117 13.4447 10.069 13.3938 10.1916C13.3356 10.3319 13.1687 10.4432 12.8349 10.6657L10.0771 12.5042C9.67306 12.7736 9.47105 12.9083 9.30353 12.8983C9.15759 12.8896 9.02278 12.8174 8.93457 12.7008C8.83333 12.567 8.83333 12.3242 8.83333 11.8386Z"
        fill="currentColor"
      />
    </g>
  </svg>
)

export const ShuffleIcon: FC<IconProps> = (props) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.1162 2.58799C15.7971 2.30788 15.3114 2.33947 15.0313 2.65853C14.7512 2.9776 14.7828 3.46332 15.1018 3.74342L15.6912 4.26083H13.1313L12.9954 4.26075C12.2423 4.26002 11.6523 4.25945 11.1362 4.47037C10.6838 4.65531 10.2872 4.95474 9.98535 5.33927C9.64117 5.7778 9.48012 6.34541 9.27455 7.06993L9.2374 7.20068L7.76301 12.3781C7.50104 13.298 7.41702 13.5422 7.2843 13.7113C7.14712 13.8861 6.96684 14.0222 6.76117 14.1063C6.56218 14.1876 6.30428 14.2015 5.34778 14.2015H3.57782C3.15326 14.2015 2.80907 14.5457 2.80907 14.9703C2.80907 15.3949 3.15326 15.739 3.57782 15.739H5.34778L5.48371 15.7391C6.23683 15.7398 6.82684 15.7404 7.34288 15.5295C7.79536 15.3446 8.19197 15.0451 8.49377 14.6606C8.83795 14.2221 8.999 13.6545 9.20457 12.9299L9.24172 12.7992L10.7161 7.62178C10.9781 6.70186 11.0621 6.45764 11.1948 6.28853C11.332 6.11375 11.5123 5.97764 11.718 5.89358C11.9169 5.81224 12.1748 5.79833 13.1313 5.79833H15.6912L15.1018 6.31575C14.7828 6.59585 14.7512 7.08157 15.0313 7.40063C15.3114 7.7197 15.7971 7.75128 16.1162 7.47118L18.2393 5.6073C18.4056 5.46134 18.5009 5.25082 18.5009 5.02958C18.5009 4.80834 18.4056 4.59783 18.2393 4.45187L16.1162 2.58799ZM16.1162 17.4119C15.7971 17.692 15.3114 17.6605 15.0313 17.3414C14.7512 17.0223 14.7828 16.5366 15.1018 16.2565L15.6912 15.7391H10.655C10.2304 15.7391 9.88624 15.3949 9.88624 14.9703C9.88624 14.5458 10.2304 14.2016 10.655 14.2016H15.6912L15.1018 13.6842C14.7828 13.4041 14.7512 12.9184 15.0313 12.5993C15.3114 12.2802 15.7971 12.2486 16.1162 12.5287L18.2393 14.3926C18.4056 14.5386 18.5009 14.7491 18.5009 14.9703C18.5009 15.1916 18.4056 15.4021 18.2393 15.5481L16.1162 17.4119ZM3.57782 5.79839C3.15326 5.79839 2.80907 5.45421 2.80907 5.02964C2.80907 4.60507 3.15326 4.26089 3.57782 4.26089H7.82413C8.24869 4.26089 8.59288 4.60507 8.59288 5.02964C8.59288 5.45421 8.24869 5.79839 7.82413 5.79839H3.57782Z"
      fill="currentColor"
    />
  </svg>
)

export const PreviousIcon: FC<IconProps> = (props) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.94444 2.5C5.32798 2.5 5.63889 2.81091 5.63889 3.19444V8.56061L14.9982 3.45553C15.7876 3.02497 16.75 3.5963 16.75 4.49547V15.5045C16.75 16.4037 15.7876 16.975 14.9982 16.5445L5.63889 11.4394V16.8056C5.63889 17.1891 5.32798 17.5 4.94444 17.5C4.56091 17.5 4.25 17.1891 4.25 16.8056V3.19444C4.25 2.81091 4.56091 2.5 4.94444 2.5Z"
      fill="currentColor"
    />
  </svg>
)

export const NextIcon: FC<IconProps> = (props) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0556 2.5C15.672 2.5 15.3611 2.81091 15.3611 3.19444V8.5606L6.00182 3.45553C5.21244 3.02497 4.25 3.5963 4.25 4.49547V15.5045C4.25 16.4037 5.21245 16.975 6.00182 16.5445L15.3611 11.4394V16.8056C15.3611 17.1891 15.672 17.5 16.0556 17.5C16.4391 17.5 16.75 17.1891 16.75 16.8056V3.19444C16.75 2.81091 16.4391 2.5 16.0556 2.5Z"
      fill="currentColor"
    />
  </svg>
)

export const RecordIcon: FC<IconProps> = (props) => (
  <svg viewBox="0 0 100 100" {...props}>
    <circle cx="50" cy="50" r="50" fill="currentColor" />
  </svg>
)

export const ClipboardCheckIcon: FC<IconProps> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.82809 3.15376C5.91811 3.13439 6.0175 3.12198 6.1504 3.11404C6.41809 4.06757 7.29386 4.76673 8.33293 4.76673H11.6663C12.7053 4.76673 13.5811 4.06757 13.8488 3.11404C13.9817 3.12198 14.0811 3.13439 14.1711 3.15376C15.0935 3.35224 15.8141 4.07279 16.0126 4.99523C16.0629 5.22906 16.0663 5.52609 16.0663 6.30959V13.5334C16.0663 14.3834 16.0658 14.9848 16.0274 15.4549C15.9895 15.9181 15.9179 16.2008 15.8047 16.423C15.5746 16.8746 15.2074 17.2417 14.7558 17.4718C14.5337 17.585 14.2509 17.6567 13.7878 17.6945C13.3176 17.7329 12.7162 17.7334 11.8663 17.7334H8.13293C7.28295 17.7334 6.68155 17.7329 6.21139 17.6945C5.74824 17.6567 5.46554 17.585 5.24335 17.4718C4.79176 17.2417 4.42461 16.8746 4.19451 16.423C4.0813 16.2008 4.00965 15.9181 3.97181 15.4549C3.9334 14.9848 3.93293 14.3834 3.93293 13.5334V6.30959C3.93293 5.52609 3.93631 5.22906 3.98663 4.99522C4.1851 4.07279 4.90565 3.35224 5.82809 3.15376ZM14.4235 1.98061C14.2526 1.94383 14.0691 1.92382 13.8562 1.91294C13.5975 0.945709 12.7151 0.233398 11.6663 0.233398H8.33293C7.28413 0.233398 6.40171 0.945708 6.14304 1.91294C5.93011 1.92382 5.74662 1.94383 5.57567 1.98061C4.19202 2.27832 3.11119 3.35915 2.81347 4.74281C2.73272 5.11812 2.7328 5.55391 2.73292 6.22887L2.73293 6.30959V13.5334L2.73293 13.5597C2.73292 14.3775 2.73292 15.0279 2.77579 15.5527C2.8197 16.09 2.91153 16.5482 3.12531 16.9678C3.47045 17.6451 4.02118 18.1959 4.69856 18.541C5.11811 18.7548 5.57631 18.8466 6.11367 18.8905C6.63842 18.9334 7.28882 18.9334 8.10663 18.9334H8.13293H11.8663H11.8926C12.7104 18.9334 13.3608 18.9334 13.8855 18.8905C14.4229 18.8466 14.8811 18.7548 15.3006 18.541C15.978 18.1959 16.5287 17.6451 16.8739 16.9678C17.0877 16.5482 17.1795 16.09 17.2234 15.5527C17.2663 15.0279 17.2663 14.3775 17.2663 13.5596V13.5334V6.30959L17.2663 6.22888V6.22885C17.2664 5.5539 17.2665 5.11812 17.1857 4.74281C16.888 3.35915 15.8072 2.27832 14.4235 1.98061ZM8.33293 1.4334C7.74382 1.4334 7.26626 1.91096 7.26626 2.50007C7.26626 3.08917 7.74382 3.56673 8.33293 3.56673H11.6663C12.2554 3.56673 12.7329 3.08917 12.7329 2.50007C12.7329 1.91096 12.2554 1.4334 11.6663 1.4334H8.33293ZM12.9239 9.591C13.1582 9.35668 13.1582 8.97678 12.9239 8.74247C12.6895 8.50815 12.3096 8.50815 12.0753 8.74247L9.16626 11.6515L8.34053 10.8258C8.10621 10.5915 7.72631 10.5915 7.492 10.8258C7.25768 11.0601 7.25768 11.44 7.492 11.6743L8.742 12.9243C8.97631 13.1586 9.35621 13.1586 9.59053 12.9243L12.9239 9.591Z"
      fill="currentColor"
    />
  </svg>
)

export const CloudUploadIcon: FC<IconProps> = (props) => (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.8327 21.3333L16.4993 16L11.166 21.3333"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 16V28"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.6866 24.5199C28.9871 23.8109 30.0144 22.6891 30.6064 21.3314C31.1985 19.9737 31.3216 18.4575 30.9562 17.0221C30.5909 15.5868 29.7579 14.3139 28.5888 13.4045C27.4198 12.4951 25.9811 12.0009 24.4999 11.9999H22.8199C22.4164 10.4389 21.6642 8.98968 20.6199 7.76122C19.5756 6.53277 18.2664 5.55703 16.7907 4.90737C15.3151 4.25772 13.7113 3.95104 12.1001 4.01041C10.4889 4.06977 8.91204 4.49363 7.48818 5.25012C6.06433 6.0066 4.8305 7.07603 3.87944 8.37801C2.92839 9.67998 2.28487 11.1806 1.99725 12.7671C1.70964 14.3536 1.78542 15.9846 2.2189 17.5376C2.65238 19.0906 3.43227 20.525 4.49995 21.7332"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.8327 21.3333L16.4993 16L11.166 21.3333"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const FileCrossIcon: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.83321 0.834696C8.70883 0.833396 8.57753 0.833458 8.43805 0.833525L8.34298 0.833555H6.6665L6.62992 0.833555C5.7182 0.833541 4.98332 0.83353 4.40534 0.911237C3.80527 0.991915 3.30002 1.16451 2.89874 1.56579C2.49746 1.96707 2.32486 2.47232 2.24419 3.07239C2.16648 3.65036 2.16649 4.38524 2.1665 5.29696V5.29697V5.33355V10.6669V10.7035V10.7035C2.16649 11.6152 2.16648 12.3501 2.24419 12.9281C2.32486 13.5281 2.49746 14.0334 2.89874 14.4347C3.30002 14.8359 3.80527 15.0085 4.40534 15.0892C4.98331 15.1669 5.71819 15.1669 6.62991 15.1669H6.66651H9.33317H9.36977C10.2815 15.1669 11.0164 15.1669 11.5943 15.0892C12.1944 15.0085 12.6997 14.8359 13.1009 14.4347C13.5022 14.0334 13.6748 13.5281 13.7555 12.9281C13.8332 12.3501 13.8332 11.6152 13.8332 10.7035V10.6669V6.32374L13.8332 6.22867C13.8333 6.08919 13.8333 5.9579 13.832 5.83352H11.9999L11.9652 5.83352C11.3662 5.83354 10.8667 5.83355 10.4702 5.78024C10.0517 5.72397 9.67383 5.60019 9.37018 5.29655C9.06654 4.9929 8.94276 4.61503 8.88649 4.1965C8.83318 3.79998 8.83319 3.3005 8.83321 2.70151L8.83321 2.66685V0.834696ZM13.7389 4.83352C13.714 4.73228 13.6826 4.63451 13.6429 4.53861C13.452 4.07769 13.0954 3.7215 12.5824 3.20897L12.5824 3.20896L12.5152 3.14176L11.525 2.15157L11.4578 2.08433C10.9452 1.5713 10.589 1.21477 10.1281 1.02386C10.0322 0.984132 9.93445 0.952683 9.83321 0.927789V2.66685C9.83321 3.30952 9.83427 3.74123 9.87757 4.06326C9.91893 4.3709 9.99041 4.50256 10.0773 4.58944C10.1642 4.67632 10.2958 4.7478 10.6035 4.78916C10.9255 4.83245 11.3572 4.83352 11.9999 4.83352H13.7389ZM6.31299 7.64663C6.50825 7.45137 6.82484 7.45137 7.0201 7.64663L7.99988 8.62641L8.97966 7.64663C9.17492 7.45137 9.4915 7.45137 9.68677 7.64663C9.88203 7.84189 9.88203 8.15847 9.68677 8.35374L8.70698 9.33352L9.68677 10.3133C9.88203 10.5086 9.88203 10.8251 9.68677 11.0204C9.4915 11.2157 9.17492 11.2157 8.97966 11.0204L7.99988 10.0406L7.0201 11.0204C6.82484 11.2157 6.50825 11.2157 6.31299 11.0204C6.11773 10.8251 6.11773 10.5086 6.31299 10.3133L7.29277 9.33352L6.31299 8.35374C6.11773 8.15847 6.11773 7.84189 6.31299 7.64663Z"
      fill="currentColor"
    />
  </svg>
)

export const FileCheckIcon: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.83333 0.834698C8.70892 0.833396 8.57758 0.833458 8.43805 0.833525L8.34298 0.833555H6.6665L6.62992 0.833555C5.7182 0.833541 4.98332 0.83353 4.40534 0.911237C3.80527 0.991915 3.30002 1.16451 2.89874 1.56579C2.49746 1.96707 2.32486 2.47232 2.24419 3.07239C2.16648 3.65036 2.16649 4.38524 2.1665 5.29696V5.29697V5.33355V10.6669V10.7035V10.7035C2.16649 11.6152 2.16648 12.3501 2.24419 12.9281C2.32486 13.5281 2.49746 14.0334 2.89874 14.4347C3.30002 14.8359 3.80527 15.0085 4.40534 15.0892C4.98332 15.1669 5.71821 15.1669 6.62994 15.1669H6.66651H9.33317H9.36974C10.2815 15.1669 11.0164 15.1669 11.5943 15.0892C12.1944 15.0085 12.6997 14.8359 13.1009 14.4347C13.5022 14.0334 13.6748 13.5281 13.7555 12.9281C13.8332 12.3501 13.8332 11.6152 13.8332 10.7035V10.6669V6.32374L13.8332 6.22867C13.8333 6.08913 13.8333 5.95777 13.832 5.83333H12L11.9653 5.83333C11.3663 5.83335 10.8669 5.83337 10.4703 5.78006C10.0518 5.72379 9.67395 5.60001 9.37031 5.29636C9.06666 4.99272 8.94288 4.61485 8.88661 4.19632C8.8333 3.7998 8.83331 3.30032 8.83333 2.70133L8.83333 2.66667V0.834698ZM13.7389 4.83333C13.714 4.73216 13.6826 4.63445 13.6429 4.53861C13.452 4.07769 13.0954 3.7215 12.5824 3.20897L12.5152 3.14176L11.525 2.15157L11.4578 2.08433C10.9452 1.5713 10.589 1.21477 10.1281 1.02386C10.0323 0.984147 9.93453 0.952708 9.83333 0.927819V2.66667C9.83333 3.30934 9.8344 3.74105 9.87769 4.06307C9.91905 4.37071 9.99053 4.50238 10.0774 4.58926C10.1643 4.67613 10.296 4.74762 10.6036 4.78898C10.9256 4.83227 11.3573 4.83333 12 4.83333H13.7389ZM10.3536 7.64645C10.5488 7.84171 10.5488 8.15829 10.3536 8.35355L7.68689 11.0202C7.59312 11.114 7.46594 11.1667 7.33333 11.1667C7.20073 11.1667 7.07355 11.114 6.97978 11.0202L5.97978 10.0202C5.78452 9.82496 5.78452 9.50838 5.97978 9.31311C6.17504 9.11785 6.49163 9.11785 6.68689 9.31311L7.33333 9.95956L9.64645 7.64645C9.84171 7.45118 10.1583 7.45118 10.3536 7.64645Z"
      fill="currentColor"
    />
  </svg>
)

// export const RepeatIcon: FC<IconProps> = (props) => (
//   <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M0.833496 8.00016C0.833496 4.04319 4.01925 0.833496 8.00016 0.833496C10.3692 0.833496 12.1446 1.81281 13.3184 2.78114C13.6472 3.05246 13.93 3.32373 14.1668 3.57391V2.66683C14.1668 2.39069 14.3907 2.16683 14.6668 2.16683C14.943 2.16683 15.1668 2.39069 15.1668 2.66683V5.00016C15.1668 5.27631 14.943 5.50016 14.6668 5.50016H12.3335C12.0574 5.50016 11.8335 5.27631 11.8335 5.00016C11.8335 4.72402 12.0574 4.50016 12.3335 4.50016H13.6581C13.4104 4.21735 13.0849 3.88489 12.682 3.55252C11.6335 2.68752 10.0756 1.8335 8.00016 1.8335C4.57367 1.8335 1.8335 4.59334 1.8335 8.00016C1.8335 8.2763 1.60964 8.50016 1.3335 8.50016C1.05735 8.50016 0.833496 8.2763 0.833496 8.00016ZM14.6668 7.50016C14.943 7.50016 15.1668 7.72402 15.1668 8.00016C15.1668 11.9582 11.9582 15.1668 8.00016 15.1668C5.98871 15.1668 4.37513 14.1663 3.2888 13.2086C2.98824 12.9436 2.72458 12.6789 2.50016 12.4344V13.3335C2.50016 13.6096 2.27631 13.8335 2.00016 13.8335C1.72402 13.8335 1.50016 13.6096 1.50016 13.3335V11.0002C1.50016 10.724 1.72402 10.5002 2.00016 10.5002H4.3335C4.60964 10.5002 4.8335 10.724 4.8335 11.0002C4.8335 11.2763 4.60964 11.5002 4.3335 11.5002H3.00834C3.25303 11.7864 3.56934 12.1228 3.9501 12.4584C4.9433 13.3341 6.32971 14.1668 8.00016 14.1668C11.4059 14.1668 14.1668 11.4059 14.1668 8.00016C14.1668 7.72402 14.3907 7.50016 14.6668 7.50016Z"
//       fill="#22272F"
//     />
//   </svg>
// )

export const EditIcon: FC<IconProps> = (props) => (
  <svg
    width="20"
    height="23"
    viewBox="0 0 20 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5605 2.60239C14.2427 2.31345 13.7573 2.31345 13.4395 2.60237C13.427 2.6137 13.4107 2.62977 13.3536 2.68693L13.149 2.89153C13.1328 3.60897 13.7243 4.20059 14.4417 4.1845L14.6464 3.97979C14.7036 3.92263 14.7197 3.90636 14.731 3.89389C15.0199 3.57606 15.0199 3.09068 14.731 2.77284C14.7197 2.76037 14.7036 2.74411 14.6464 2.68695C14.5893 2.62979 14.573 2.61372 14.5605 2.60239ZM13.5945 5.03175C13.0043 4.80129 12.5321 4.32907 12.3017 3.73884L8.5225 7.51794C8.20034 7.84009 8.07921 7.96335 7.98191 8.09871C7.89069 8.2256 7.81347 8.36199 7.75159 8.50549C7.68558 8.65857 7.64221 8.82585 7.53171 9.26784L7.35379 9.97953L8.06549 9.80161C8.50748 9.69111 8.67476 9.64774 8.82784 9.58173C8.97134 9.51985 9.10772 9.44263 9.23461 9.35142C9.36997 9.25412 9.49323 9.13299 9.81538 8.81084L13.5945 5.03175ZM12.7668 1.8624C13.4661 1.22676 14.534 1.22678 15.2332 1.86243C15.2657 1.89201 15.3003 1.92659 15.3452 1.9715L15.3536 1.97986L15.3619 1.98821C15.4068 2.0331 15.4414 2.06767 15.471 2.10022C16.1066 2.79947 16.1066 3.86729 15.471 4.56654C15.4414 4.59905 15.4069 4.63359 15.362 4.67842L15.3619 4.67848L15.3619 4.67851L15.3535 4.68689L10.5225 9.51794L10.4931 9.54733L10.4931 9.54735C10.2101 9.8304 10.0276 10.0129 9.81831 10.1634C9.63285 10.2967 9.43352 10.4096 9.22379 10.5C8.98708 10.6021 8.73667 10.6646 8.34834 10.7617L8.30803 10.7717L6.78787 11.1518C6.61749 11.1944 6.43724 11.1445 6.31305 11.0203C6.18886 10.8961 6.13894 10.7158 6.18153 10.5454L6.56157 9.02531L6.57165 8.98498C6.66868 8.59665 6.73125 8.34624 6.83332 8.10954C6.92375 7.8998 7.03662 7.70046 7.16994 7.51501C7.3204 7.30571 7.50293 7.12321 7.786 6.84022L7.8154 6.81083L12.6465 1.97981L12.6549 1.97143L12.6549 1.97142L12.6549 1.97137C12.6998 1.92651 12.7343 1.89196 12.7668 1.8624ZM4.16675 14C4.16675 13.7239 4.39061 13.5 4.66675 13.5H15.3334C15.6096 13.5 15.8334 13.7239 15.8334 14C15.8334 14.2762 15.6096 14.5 15.3334 14.5H4.66675C4.39061 14.5 4.16675 14.2762 4.16675 14Z"
      fill="currentColor"
    />
  </svg>
)

export const StretchIcon: FC<IconProps> = (props) => (
  <svg
    width="11"
    height="7"
    viewBox="0 0 11 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.0562 0.170859C7.83899 -0.056953 7.48684 -0.056953 7.26963 0.170858C7.05244 0.39867 7.05244 0.768012 7.26963 0.995823L9.65727 3.50001L7.26963 6.0042C7.05244 6.23201 7.05244 6.60136 7.26963 6.82918C7.48684 7.05694 7.83899 7.05694 8.0562 6.82918L10.8371 3.9125C10.9414 3.80309 11 3.65471 11 3.50001C11 3.3453 10.9414 3.19692 10.8371 3.08753L8.0562 0.170859ZM2.94378 6.82918C3.16099 7.05694 3.51314 7.05694 3.73035 6.82918C3.94754 6.60136 3.94754 6.23201 3.73035 6.0042L1.34271 3.50001L3.73035 0.995823C3.94754 0.768012 3.94754 0.39867 3.73035 0.170858C3.51314 -0.0569532 3.16099 -0.0569532 2.94378 0.170858L0.162868 3.08753C-0.05429 3.31534 -0.05429 3.68468 0.162868 3.91249L2.94378 6.82918Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.0562 0.170859C7.83899 -0.056953 7.48684 -0.056953 7.26963 0.170858C7.05244 0.39867 7.05244 0.768012 7.26963 0.995823L9.65727 3.50001L7.26963 6.0042C7.05244 6.23201 7.05244 6.60136 7.26963 6.82918C7.48684 7.05694 7.83899 7.05694 8.0562 6.82918L10.8371 3.9125C10.9414 3.80309 11 3.65471 11 3.50001C11 3.3453 10.9414 3.19692 10.8371 3.08753L8.0562 0.170859Z"
      fill="currentColor"
    />
    <path d="M1 3.5H10" stroke="currentColor" />
  </svg>
)

export const MidiRectangleIcon: FC<IconProps> = (props) => (
  <svg
    width="45"
    height="24"
    viewBox="0 0 45 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="44.7972" height="24" rx="6" fill="#EBEBEB" />
    <rect x="18.0308" y="8.06714" width="3.12487" height="2.62186" rx="1" fill="#707070" />
    <rect x="25.9849" y="8.06714" width="3.12487" height="2.62186" rx="1" fill="#707070" />
    <rect x="11" y="8.06714" width="3.12487" height="2.62186" rx="1" fill="#707070" />
    <rect x="14.9062" y="13.3108" width="3.12487" height="2.62186" rx="1" fill="#707070" />
    <rect x="22.7183" y="13.3108" width="3.12487" height="2.62186" rx="1" fill="#707070" />
    <rect x="30.6724" y="13.311" width="3.12487" height="2.62186" rx="1" fill="#707070" />
  </svg>
)

export const AudioRectangleIcon: FC<IconProps> = (props) => (
  <svg
    width="47"
    height="24"
    viewBox="0 0 47 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="46.0842" height="24" rx="6" fill="#EBEBEB" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.9659 6.27173C19.9659 5.85752 19.6301 5.52173 19.2159 5.52173C18.8017 5.52173 18.4659 5.85752 18.4659 6.27173L18.4659 17.7281C18.4659 18.1423 18.8017 18.4781 19.2159 18.4781C19.6301 18.4781 19.9659 18.1423 19.9659 17.7281L19.9659 6.27173ZM15.6695 8.88298C16.0837 8.88298 16.4195 9.21877 16.4195 9.63298L16.4195 13.77C16.4195 14.1842 16.0837 14.52 15.6695 14.52C15.2553 14.52 14.9195 14.1842 14.9195 13.77L14.9195 9.63298C14.9195 9.21877 15.2553 8.88298 15.6695 8.88298ZM11.75 10.6135C12.1642 10.6135 12.5 10.9493 12.5 11.3635L12.5 12.6364C12.5 13.0506 12.1642 13.3864 11.75 13.3864C11.3358 13.3864 11 13.0506 11 12.6364L11 11.3635C11 10.9493 11.3358 10.6135 11.75 10.6135ZM22.9486 8.06755C23.3628 8.06755 23.6986 8.40334 23.6986 8.81755L23.6986 15.1822C23.6986 15.5964 23.3628 15.9322 22.9486 15.9322C22.5344 15.9322 22.1986 15.5964 22.1986 15.1822L22.1986 8.81755C22.1986 8.40334 22.5344 8.06755 22.9486 8.06755ZM27.4317 11.3635C27.4317 10.9493 27.0959 10.6135 26.6817 10.6135C26.2675 10.6135 25.9317 10.9493 25.9317 11.3635L25.9317 12.6364C25.9317 13.0506 26.2675 13.3864 26.6817 13.3864C27.0959 13.3864 27.4317 13.0506 27.4317 12.6364L27.4317 11.3635Z"
      fill="#707070"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.3516 8.59863C31.3516 8.18442 31.0158 7.84863 30.6016 7.84863C30.1873 7.84863 29.8516 8.18442 29.8516 8.59863L29.8516 14.8042C29.8516 15.2184 30.1873 15.5542 30.6016 15.5542C31.0158 15.5542 31.3516 15.2184 31.3516 14.8042L31.3516 8.59863ZM35.0843 10.6672C35.0843 10.253 34.7485 9.9172 34.3343 9.9172C33.9201 9.9172 33.5843 10.253 33.5843 10.6672L33.5843 12.7357C33.5843 13.1499 33.9201 13.4857 34.3343 13.4857C34.7485 13.4857 35.0843 13.1499 35.0843 12.7357L35.0843 10.6672Z"
      fill="#707070"
    />
  </svg>
)

export const ScissorsIcon: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 6C5.10457 6 6 5.10457 6 4C6 2.89543 5.10457 2 4 2C2.89543 2 2 2.89543 2 4C2 5.10457 2.89543 6 4 6Z"
      stroke="currentColor"
      strokeWidth="0.941176"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 14C5.10457 14 6 13.1046 6 12C6 10.8954 5.10457 10 4 10C2.89543 10 2 10.8954 2 12C2 13.1046 2.89543 14 4 14Z"
      stroke="currentColor"
      strokeWidth="0.941176"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3331 2.66675L5.41309 10.5867"
      stroke="currentColor"
      strokeWidth="0.941176"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.64648 9.65332L13.3332 13.3333"
      stroke="currentColor"
      strokeWidth="0.941176"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.41309 5.41333L7.99975 8"
      stroke="currentColor"
      strokeWidth="0.941176"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ChevronLeft: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    ></path>
  </svg>
)

export const ChevronRight: React.FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.1584 3.13508C6.35985 2.94621 6.67627 2.95642 6.86514 3.15788L10.6151 7.15788C10.7954 7.3502 10.7954 7.64949 10.6151 7.84182L6.86514 11.8418C6.67627 12.0433 6.35985 12.0535 6.1584 11.8646C5.95694 11.6757 5.94673 11.3593 6.1356 11.1579L9.565 7.49985L6.1356 3.84182C5.94673 3.64036 5.95694 3.32394 6.1584 3.13508Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    ></path>
  </svg>
)

export const ChevronDown: React.FC<IconProps> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 7.5L10 12.5L15 7.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={'1.5px'}
    />
  </svg>
)

export const ChevronUp: React.FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M12 10L8 6L4 10" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export const SampleDrawerIcon: React.FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.94444 12.6111V2.98148L14.8333 1.5V11.1296M5.94444 12.6111C5.94444 13.8384 4.94952 14.8333 3.72222 14.8333C2.49492 14.8333 1.5 13.8384 1.5 12.6111C1.5 11.3838 2.49492 10.3889 3.72222 10.3889C4.94952 10.3889 5.94444 11.3838 5.94444 12.6111ZM14.8333 11.1296C14.8333 12.3569 13.8384 13.3519 12.6111 13.3519C11.3838 13.3519 10.3889 12.3569 10.3889 11.1296C10.3889 9.90233 11.3838 8.90741 12.6111 8.90741C13.8384 8.90741 14.8333 9.90233 14.8333 11.1296Z"
      stroke="#F4F4F4"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const StemDrawerIcon: React.FC<IconProps> = (props) => (
  <svg
    width="24"
    height="20"
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="12" width="11.25" height="5" fill="#F4F4F4" />
    <rect x="0.75" y="5" width="11.25" height="5" fill="#F4F4F4" />
    <rect x="12" y="10" width="11.25" height="5" fill="#F4F4F4" />
    <rect x="0.75" y="15" width="11.25" height="5" fill="#F4F4F4" />
  </svg>
)

export const ArrowUpLeftIcon: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fill="none"
      d="M5.99996 9.33335L2.66663 6.00002M2.66663 6.00002L5.99996 2.66669M2.66663 6.00002H10.6666C11.3739 6.00002 12.0521 6.28097 12.5522 6.78107C13.0523 7.28117 13.3333 7.95944 13.3333 8.66669V13.3334"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ArrowUpRightIcon: React.FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fill="none"
      d="M10 9.33335L13.3334 6.00002M13.3334 6.00002L10 2.66669M13.3334 6.00002H5.33335C4.62611 6.00002 3.94783 6.28097 3.44774 6.78107C2.94764 7.28117 2.66669 7.95944 2.66669 8.66669V13.3334"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ArrowDownIcon: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.29289 15.7071C7.68342 16.0976 8.31658 16.0976 8.70711 15.7071L15.0711 9.34315C15.4616 8.95262 15.4616 8.31946 15.0711 7.92893C14.6805 7.53841 14.0474 7.53841 13.6569 7.92893L8 13.5858L2.34315 7.92893C1.95262 7.53841 1.31946 7.53841 0.928933 7.92893C0.538408 8.31946 0.538408 8.95262 0.928933 9.34315L7.29289 15.7071ZM7 4.37114e-08L7 15L9 15L9 -4.37114e-08L7 4.37114e-08Z"
      fill="black"
    />
  </svg>
)

export const StemIcon: FC<IconProps> = (props) => (
  <svg
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="16" y="5.33331" width="12" height="5.33333" fill="currentColor" />
    <rect x="4" y="10.6667" width="12" height="5.33333" fill="currentColor" />
    <rect x="16" y="16" width="12" height="5.33333" fill="currentColor" />
    <rect x="4" y="21.3333" width="12" height="5.33333" fill="currentColor" />
  </svg>
)

export const DotsIcon: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8889 7.55557C11.8889 8.41114 12.5889 9.11114 13.4444 9.11114C14.3 9.11114 15 8.41114 15 7.55557C15 6.70001 14.3 6 13.4444 6C12.5889 6 11.8889 6.70001 11.8889 7.55557ZM9.55538 7.55557C9.55538 6.70001 8.85537 6 7.99981 6C7.14425 6 6.44424 6.70001 6.44424 7.55557C6.44424 8.41114 7.14425 9.11114 7.99981 9.11114C8.85537 9.11114 9.55538 8.41114 9.55538 7.55557ZM2.55572 6C3.41128 6 4.11129 6.70001 4.11129 7.55557C4.11129 8.41114 3.41128 9.11114 2.55572 9.11114C1.70015 9.11114 1.00015 8.41114 1.00015 7.55557C1.00015 6.70001 1.70015 6 2.55572 6Z"
      fill="#141414"
    />
  </svg>
)
export const SpinnerIcon: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 1C3.91015 1 1 3.91015 1 7.5C1 11.0899 3.91015 14 7.5 14C11.0899 14 14 11.0899 14 7.5H12C12 9.98528 9.98528 12 7.5 12C5.01472 12 3 9.98528 3 7.5C3 5.01472 5.01472 3 7.5 3V1Z"
      fill="currentColor"
    />
  </svg>
)

export const CheckmarkIcon: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M2.5 7.5L6.5 11.5L13.5 4.5" stroke="currentColor" strokeWidth="1.5" />
  </svg>
)

export const CloseIcon: FC<IconProps> = (props) => (
  <svg
    width="15px"
    height="15px"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
)

export const GearIcon: FC<IconProps> = (props) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.25 11.5C10.4926 11.5 11.5 10.4926 11.5 9.25C11.5 8.00736 10.4926 7 9.25 7C8.00736 7 7 8.00736 7 9.25C7 10.4926 8.00736 11.5 9.25 11.5Z"
      stroke="#3E3E3E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.8 11.5C14.7002 11.7262 14.6704 11.9771 14.7145 12.2204C14.7586 12.4637 14.8746 12.6882 15.0475 12.865L15.0925 12.91C15.232 13.0493 15.3426 13.2147 15.4181 13.3968C15.4936 13.5789 15.5324 13.7741 15.5324 13.9713C15.5324 14.1684 15.4936 14.3636 15.4181 14.5457C15.3426 14.7278 15.232 14.8932 15.0925 15.0325C14.9532 15.172 14.7878 15.2826 14.6057 15.3581C14.4236 15.4336 14.2284 15.4724 14.0312 15.4724C13.8341 15.4724 13.6389 15.4336 13.4568 15.3581C13.2747 15.2826 13.1093 15.172 12.97 15.0325L12.925 14.9875C12.7482 14.8146 12.5237 14.6986 12.2804 14.6545C12.0371 14.6104 11.7862 14.6402 11.56 14.74C11.3382 14.8351 11.149 14.9929 11.0157 15.1942C10.8825 15.3954 10.811 15.6312 10.81 15.8725V16C10.81 16.3978 10.652 16.7794 10.3707 17.0607C10.0894 17.342 9.70782 17.5 9.31 17.5C8.91218 17.5 8.53064 17.342 8.24934 17.0607C7.96804 16.7794 7.81 16.3978 7.81 16V15.9325C7.80419 15.6843 7.72384 15.4435 7.57938 15.2415C7.43493 15.0396 7.23305 14.8857 7 14.8C6.77379 14.7002 6.52286 14.6704 6.27956 14.7145C6.03626 14.7586 5.81176 14.8746 5.635 15.0475L5.59 15.0925C5.45069 15.232 5.28526 15.3426 5.10316 15.4181C4.92106 15.4936 4.72587 15.5324 4.52875 15.5324C4.33163 15.5324 4.13644 15.4936 3.95434 15.4181C3.77224 15.3426 3.60681 15.232 3.4675 15.0925C3.32804 14.9532 3.2174 14.7878 3.14191 14.6057C3.06642 14.4236 3.02757 14.2284 3.02757 14.0312C3.02757 13.8341 3.06642 13.6389 3.14191 13.4568C3.2174 13.2747 3.32804 13.1093 3.4675 12.97L3.5125 12.925C3.6854 12.7482 3.80139 12.5237 3.8455 12.2804C3.88962 12.0371 3.85984 11.7862 3.76 11.56C3.66493 11.3382 3.50707 11.149 3.30585 11.0157C3.10463 10.8825 2.86884 10.811 2.6275 10.81H2.5C2.10218 10.81 1.72064 10.652 1.43934 10.3707C1.15804 10.0894 1 9.70782 1 9.31C1 8.91218 1.15804 8.53064 1.43934 8.24934C1.72064 7.96804 2.10218 7.81 2.5 7.81H2.5675C2.81575 7.80419 3.0565 7.72384 3.25847 7.57938C3.46045 7.43493 3.61429 7.23305 3.7 7C3.79984 6.77379 3.82962 6.52286 3.7855 6.27956C3.74139 6.03626 3.6254 5.81176 3.4525 5.635L3.4075 5.59C3.26804 5.45069 3.1574 5.28526 3.08191 5.10316C3.00642 4.92106 2.96757 4.72587 2.96757 4.52875C2.96757 4.33163 3.00642 4.13644 3.08191 3.95434C3.1574 3.77224 3.26804 3.60681 3.4075 3.4675C3.54681 3.32804 3.71224 3.2174 3.89434 3.14191C4.07644 3.06642 4.27163 3.02757 4.46875 3.02757C4.66587 3.02757 4.86106 3.06642 5.04316 3.14191C5.22526 3.2174 5.39069 3.32804 5.53 3.4675L5.575 3.5125C5.75176 3.6854 5.97626 3.80139 6.21956 3.8455C6.46285 3.88962 6.71379 3.85984 6.94 3.76H7C7.22183 3.66493 7.41101 3.50707 7.54427 3.30585C7.67753 3.10463 7.74904 2.86884 7.75 2.6275V2.5C7.75 2.10218 7.90804 1.72064 8.18934 1.43934C8.47064 1.15804 8.85218 1 9.25 1C9.64782 1 10.0294 1.15804 10.3107 1.43934C10.592 1.72064 10.75 2.10218 10.75 2.5V2.5675C10.751 2.80884 10.8225 3.04463 10.9557 3.24585C11.089 3.44707 11.2782 3.60493 11.5 3.7C11.7262 3.79984 11.9771 3.82962 12.2204 3.7855C12.4637 3.74139 12.6882 3.6254 12.865 3.4525L12.91 3.4075C13.0493 3.26804 13.2147 3.1574 13.3968 3.08191C13.5789 3.00642 13.7741 2.96757 13.9713 2.96757C14.1684 2.96757 14.3636 3.00642 14.5457 3.08191C14.7278 3.1574 14.8932 3.26804 15.0325 3.4075C15.172 3.54681 15.2826 3.71224 15.3581 3.89434C15.4336 4.07644 15.4724 4.27163 15.4724 4.46875C15.4724 4.66587 15.4336 4.86106 15.3581 5.04316C15.2826 5.22526 15.172 5.39069 15.0325 5.53L14.9875 5.575C14.8146 5.75176 14.6986 5.97626 14.6545 6.21956C14.6104 6.46285 14.6402 6.71379 14.74 6.94V7C14.8351 7.22183 14.9929 7.41101 15.1942 7.54427C15.3954 7.67753 15.6312 7.74904 15.8725 7.75H16C16.3978 7.75 16.7794 7.90804 17.0607 8.18934C17.342 8.47064 17.5 8.85218 17.5 9.25C17.5 9.64782 17.342 10.0294 17.0607 10.3107C16.7794 10.592 16.3978 10.75 16 10.75H15.9325C15.6912 10.751 15.4554 10.8225 15.2542 10.9557C15.0529 11.089 14.8951 11.2782 14.8 11.5V11.5Z"
      stroke="#3E3E3E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const SearchIcon: FC<IconProps> = (props) => (
  <svg
    width="15px"
    height="15px"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5ZM9.30884 10.0159C8.53901 10.6318 7.56251 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 7.56251 10.6318 8.53901 10.0159 9.30884L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L9.30884 10.0159Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
)

export const PlayIcon: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.orkllg/2000/svg"
    fill={props.fill || 'none'}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.1869 3.71487C5.42703 3.57009 5.72543 3.56159 5.9734 3.69247L20.3734 11.2925C20.6358 11.431 20.8 11.7033 20.8 12C20.8 12.2967 20.6358 12.569 20.3734 12.7075L5.9734 20.3075C5.72543 20.4384 5.42703 20.4299 5.1869 20.2851C4.94679 20.1403 4.79999 19.8803 4.79999 19.6V4.39998C4.79999 4.11959 4.94679 3.85966 5.1869 3.71487Z"
      fill={props.fill || 'currentColor'}
    />
  </svg>
)

export const PauseIcon: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.04995 2.74998C6.04995 2.44623 5.80371 2.19998 5.49995 2.19998C5.19619 2.19998 4.94995 2.44623 4.94995 2.74998V12.25C4.94995 12.5537 5.19619 12.8 5.49995 12.8C5.80371 12.8 6.04995 12.5537 6.04995 12.25V2.74998ZM10.05 2.74998C10.05 2.44623 9.80371 2.19998 9.49995 2.19998C9.19619 2.19998 8.94995 2.44623 8.94995 2.74998V12.25C8.94995 12.5537 9.19619 12.8 9.49995 12.8C9.80371 12.8 10.05 12.5537 10.05 12.25V2.74998Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
)

export const StopIcon: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 3C2 2.44772 2.44772 2 3 2H12C12.5523 2 13 2.44772 13 3V12C13 12.5523 12.5523 13 12 13H3C2.44772 13 2 12.5523 2 12V3Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
)

export const LinkIcon: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 2C2.44772 2 2 2.44772 2 3V12C2 12.5523 2.44772 13 3 13H12C12.5523 13 13 12.5523 13 12V8.5C13 8.22386 12.7761 8 12.5 8C12.2239 8 12 8.22386 12 8.5V12H3V3L6.5 3C6.77614 3 7 2.77614 7 2.5C7 2.22386 6.77614 2 6.5 2H3ZM12.8536 2.14645C12.9015 2.19439 12.9377 2.24964 12.9621 2.30861C12.9861 2.36669 12.9996 2.4303 13 2.497L13 2.5V2.50049V5.5C13 5.77614 12.7761 6 12.5 6C12.2239 6 12 5.77614 12 5.5V3.70711L6.85355 8.85355C6.65829 9.04882 6.34171 9.04882 6.14645 8.85355C5.95118 8.65829 5.95118 8.34171 6.14645 8.14645L11.2929 3H9.5C9.22386 3 9 2.77614 9 2.5C9 2.22386 9.22386 2 9.5 2H12.4999H12.5C12.5678 2 12.6324 2.01349 12.6914 2.03794C12.7504 2.06234 12.8056 2.09851 12.8536 2.14645Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
)

export const PlusIcon: FC<IconProps> = (props) => (
  <svg
    width="15px"
    height="15px"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 2.75C8 2.47386 7.77614 2.25 7.5 2.25C7.22386 2.25 7 2.47386 7 2.75V7H2.75C2.47386 7 2.25 7.22386 2.25 7.5C2.25 7.77614 2.47386 8 2.75 8H7V12.25C7 12.5261 7.22386 12.75 7.5 12.75C7.77614 12.75 8 12.5261 8 12.25V8H12.25C12.5261 8 12.75 7.77614 12.75 7.5C12.75 7.22386 12.5261 7 12.25 7H8V2.75Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    ></path>
  </svg>
)

export const CheckIcon: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
)

export const HeartOutlined: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill={props.fill || 'none'}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.7706 3.99663C13.5977 3.57947 13.3444 3.20045 13.025 2.88123C12.7058 2.56186 12.3268 2.30851 11.9096 2.13566C11.4924 1.96281 11.0453 1.87384 10.5938 1.87384C10.1422 1.87384 9.69508 1.96281 9.27792 2.13566C8.86075 2.30851 8.48174 2.56186 8.16251 2.88123L7.50001 3.54373L6.83751 2.88123C6.19271 2.23642 5.31816 1.87417 4.40626 1.87417C3.49437 1.87417 2.61982 2.23642 1.97501 2.88123C1.33021 3.52604 0.967957 4.40059 0.967957 5.31248C0.967957 6.22438 1.33021 7.09892 1.97501 7.74373L7.50001 13.2687L13.025 7.74373C13.3444 7.42451 13.5977 7.04549 13.7706 6.62833C13.9434 6.21117 14.0324 5.76404 14.0324 5.31248C14.0324 4.86093 13.9434 4.4138 13.7706 3.99663ZM6.13041 3.58834C5.67314 3.13107 5.05294 2.87417 4.40626 2.87417C3.75958 2.87417 3.13939 3.13107 2.68212 3.58834C2.22485 4.04561 1.96796 4.6658 1.96796 5.31248C1.96796 5.95916 2.22485 6.57935 2.68212 7.03662L7.50001 11.8545L12.3179 7.03662C12.5444 6.81027 12.7242 6.54134 12.8468 6.24554C12.9693 5.94973 13.0324 5.63267 13.0324 5.31248C13.0324 4.99229 12.9693 4.67523 12.8468 4.37943C12.7242 4.08362 12.5445 3.81486 12.3181 3.5885C12.0917 3.36204 11.8226 3.18206 11.5268 3.05949C11.231 2.93693 10.914 2.87384 10.5938 2.87384C10.2736 2.87384 9.95651 2.93693 9.66071 3.05949C9.3649 3.18206 9.09598 3.36187 8.86962 3.58834L7.50001 4.95794L6.13041 3.58834Z"
      fill={props.fill || 'currentColor'}
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
)

export const HeartFilled: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.025 2.88123C12.7057 2.56186 12.3267 2.30851 11.9095 2.13566C11.4924 1.96281 11.0453 1.87384 10.5937 1.87384C10.1421 1.87384 9.69502 1.96281 9.27786 2.13566C8.86069 2.30851 8.48168 2.56186 8.16245 2.88123L7.49995 3.54373L6.83745 2.88123C6.19264 2.23642 5.3181 1.87417 4.4062 1.87417C3.49431 1.87417 2.61976 2.23642 1.97495 2.88123C1.33014 3.52604 0.967896 4.40059 0.967896 5.31248C0.967896 6.22438 1.33014 7.09892 1.97495 7.74373L2.63745 8.40623L7.49995 13.2687L12.3625 8.40623L13.025 7.74373C13.3443 7.42451 13.5977 7.04549 13.7705 6.62833C13.9434 6.21117 14.0323 5.76404 14.0323 5.31248C14.0323 4.86093 13.9434 4.4138 13.7705 3.99663C13.5977 3.57947 13.3443 3.20045 13.025 2.88123V2.88123Z"
      fill="currentColor"
    />
  </svg>
)

export const RepeatIcon: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1233 1.66564C10.8193 1.38428 10.3448 1.40261 10.0634 1.70659C9.78205 2.01058 9.80038 2.4851 10.1044 2.76646L10.2563 2.90713H5.47125C3.59792 2.90713 2.07928 4.42576 2.07928 6.2991V6.53927C2.07928 6.95349 2.41507 7.28927 2.82928 7.28927C3.2435 7.28927 3.57928 6.95349 3.57928 6.53927V6.2991C3.57928 5.25419 4.42635 4.40713 5.47125 4.40713H10.2563L10.1044 4.54779C9.80038 4.82916 9.78205 5.30368 10.0634 5.60766C10.3448 5.91164 10.8193 5.92998 11.1233 5.64861L12.6802 4.20754C12.8335 4.06559 12.9207 3.8661 12.9207 3.65713C12.9207 3.44816 12.8335 3.24866 12.6802 3.10672L11.1233 1.66564ZM12.9207 8.46068C12.9207 8.04647 12.5849 7.71068 12.1707 7.71068C11.7565 7.71068 11.4207 8.04647 11.4207 8.46068V8.70086C11.4207 9.74577 10.5737 10.5928 9.52876 10.5928H4.74368L4.89565 10.4522C5.19964 10.1708 5.21797 9.69628 4.9366 9.3923C4.65524 9.08831 4.18072 9.06998 3.87673 9.35135L2.31983 10.7924C2.16647 10.9344 2.07928 11.1339 2.07928 11.3428C2.07928 11.5518 2.16647 11.7513 2.31983 11.8932L3.87673 13.3343C4.18072 13.6157 4.65524 13.5973 4.9366 13.2934C5.21797 12.9894 5.19964 12.5149 4.89565 12.2335L4.74368 12.0928H9.52876C11.4021 12.0928 12.9207 10.5742 12.9207 8.70086V8.46068Z"
      fill="currentColor"
    />
  </svg>
)

export const UndoIcon: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.97855 2.14645C6.17382 2.34171 6.17382 2.65829 5.97855 2.85355L3.70711 5.125H10C10.7956 5.125 11.5587 5.44107 12.1213 6.00368C12.6839 6.56629 13 7.32935 13 8.125V12.5C13 12.7761 12.7761 13 12.5 13C12.2239 13 12 12.7761 12 12.5V8.125C12 7.59457 11.7893 7.08586 11.4142 6.71079C11.0391 6.33571 10.5304 6.125 10 6.125H3.70711L5.97855 8.39645C6.17382 8.59171 6.17382 8.90829 5.97855 9.10355C5.78329 9.29882 5.46671 9.29882 5.27145 9.10355L2.14645 5.97855C1.95118 5.78329 1.95118 5.46671 2.14645 5.27145L5.27145 2.14645C5.46671 1.95118 5.78329 1.95118 5.97855 2.14645Z"
      fill="currentColor"
    />
  </svg>
)

export const RedoIcon: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.02145 2.14645C8.82618 2.34171 8.82618 2.65829 9.02145 2.85355L11.2929 5.125H5C4.20435 5.125 3.44129 5.44107 2.87868 6.00368C2.31607 6.56629 2 7.32935 2 8.125V12.5C2 12.7761 2.22386 13 2.5 13C2.77614 13 3 12.7761 3 12.5V8.125C3 7.59457 3.21071 7.08586 3.58579 6.71079C3.96086 6.33571 4.46957 6.125 5 6.125H11.2929L9.02145 8.39645C8.82618 8.59171 8.82618 8.90829 9.02145 9.10355C9.21671 9.29882 9.53329 9.29882 9.72855 9.10355L12.8536 5.97855C13.0488 5.78329 13.0488 5.46671 12.8536 5.27145L9.72855 2.14645C9.53329 1.95118 9.21671 1.95118 9.02145 2.14645Z"
      fill="currentColor"
    />
  </svg>
)

export const TrashIcon: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.49998 1.19642L7.40934 1.19638C6.86891 1.19597 6.46285 1.19565 6.10804 1.3352C5.79645 1.45775 5.52061 1.65656 5.30582 1.91341C5.08722 2.17481 4.9626 2.50756 4.81817 2.9375H1.69641C1.42027 2.9375 1.19641 3.16135 1.19641 3.4375C1.19641 3.71364 1.42027 3.9375 1.69641 3.9375H2.38567L2.76238 10.3415C2.79252 10.8541 2.81689 11.2683 2.86352 11.6034C2.91161 11.949 2.98803 12.2513 3.14433 12.5292C3.39332 12.9718 3.77123 13.3282 4.22775 13.5507C4.51433 13.6905 4.82055 13.749 5.16843 13.7767C5.50573 13.8036 5.92062 13.8036 6.43407 13.8036H8.56589C9.07934 13.8036 9.49424 13.8036 9.83153 13.7767C10.1794 13.749 10.4856 13.6905 10.7722 13.5507C11.2287 13.3282 11.6066 12.9718 11.8556 12.5292C12.0119 12.2513 12.0884 11.949 12.1364 11.6034C12.1831 11.2683 12.2074 10.8541 12.2376 10.3416L12.6143 3.9375H13.3036C13.5797 3.9375 13.8036 3.71364 13.8036 3.4375C13.8036 3.16135 13.5797 2.9375 13.3036 2.9375H10.1818C10.0374 2.50756 9.91274 2.17481 9.69415 1.91341C9.47935 1.65656 9.20352 1.45775 8.89193 1.3352C8.53712 1.19565 8.13105 1.19597 7.59062 1.19638L7.49998 1.19642ZM9.80973 3.9375C9.81745 3.93768 9.82519 3.93768 9.83295 3.9375H11.6126L11.2405 10.2621C11.2089 10.8002 11.1865 11.1745 11.146 11.4656C11.1063 11.7506 11.054 11.9145 10.9841 12.0389C10.8347 12.3045 10.6079 12.5183 10.334 12.6519C10.2057 12.7144 10.039 12.757 9.75212 12.7799C9.45921 12.8032 9.0842 12.8036 8.54519 12.8036H6.45478C5.91577 12.8036 5.54076 12.8032 5.24785 12.7799C4.96099 12.757 4.79427 12.7144 4.66597 12.6519C4.39205 12.5183 4.16531 12.3045 4.01591 12.0389C3.94594 11.9145 3.89363 11.7506 3.85397 11.4656C3.81348 11.1745 3.79109 10.8002 3.75944 10.2621L3.3874 3.9375H5.16701C5.17477 3.93768 5.18251 3.93768 5.19023 3.9375H9.80973ZM9.12083 2.9375C9.04332 2.73064 8.99207 2.6327 8.92703 2.55492C8.81963 2.42649 8.68172 2.32709 8.52592 2.26581C8.37102 2.20489 8.17292 2.19642 7.49998 2.19642C6.82704 2.19642 6.62895 2.20489 6.47404 2.26581C6.31825 2.32709 6.18033 2.42649 6.07293 2.55492C6.00789 2.6327 5.95665 2.73064 5.87913 2.9375H9.12083Z"
      fill="currentColor"
    />
  </svg>
)

export const VolumeIcon: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.0606 5.73223C10.2559 5.53697 10.5725 5.53697 10.7677 5.73223C11.744 6.70854 11.744 8.29145 10.7677 9.26776C10.5725 9.46303 10.2559 9.46303 10.0606 9.26776C9.86537 9.0725 9.86537 8.75592 10.0606 8.56066C10.6464 7.97487 10.6464 7.02512 10.0606 6.43934C9.86537 6.24408 9.86537 5.92749 10.0606 5.73223Z"
      fill="currentColor"
    />
    <path
      d="M12.8891 3.61091C12.6938 3.41565 12.3772 3.41565 12.182 3.61091C11.9867 3.80617 11.9867 4.12275 12.182 4.31801C13.9393 6.07537 13.9393 8.92462 12.182 10.682C11.9867 10.8772 11.9867 11.1938 12.182 11.3891C12.3772 11.5843 12.6938 11.5843 12.8891 11.3891C15.037 9.2412 15.037 5.75879 12.8891 3.61091Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.65689 10.5C3.87927 10.5 4.0953 10.5741 4.27083 10.7106L6.88606 12.7447C7.54292 13.2556 8.5 12.7875 8.5 11.9554V3.04464C8.5 2.21249 7.54292 1.7444 6.88606 2.25528L4.27083 4.28935C4.0953 4.42588 3.87927 4.5 3.65689 4.5H1C0.447715 4.5 0 4.94771 0 5.5V9.5C0 10.0523 0.447715 10.5 1 10.5H3.65689ZM1 5.5V9.5H3.65689C4.10164 9.5 4.53371 9.64824 4.88477 9.92129L7.5 11.9554V3.04464L4.88477 5.0787C4.53371 5.35175 4.10164 5.5 3.65689 5.5H1Z"
      fill="currentColor"
    />
  </svg>
)

export const VolumeMuteIcon: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.27083 10.7106C4.0953 10.5741 3.87927 10.5 3.65689 10.5H1C0.447715 10.5 0 10.0523 0 9.5V5.5C0 4.94771 0.447715 4.5 1 4.5H3.65689C3.87927 4.5 4.0953 4.42588 4.27083 4.28935L6.88606 2.25528C7.54292 1.7444 8.5 2.21249 8.5 3.04464V11.9554C8.5 12.7875 7.54292 13.2556 6.88606 12.7447L4.27083 10.7106ZM1 5.5V9.5H3.65689C4.10164 9.5 4.53371 9.64824 4.88477 9.92129L7.5 11.9554V3.04464L4.88477 5.0787C4.53371 5.35175 4.10164 5.5 3.65689 5.5H1ZM10.6464 5.64645C10.8417 5.45118 11.1583 5.45118 11.3536 5.64645L12.5 6.79289L13.6464 5.64645C13.8417 5.45118 14.1583 5.45118 14.3536 5.64645C14.5488 5.84171 14.5488 6.15829 14.3536 6.35355L13.2071 7.5L14.3536 8.64645C14.5488 8.84171 14.5488 9.15829 14.3536 9.35355C14.1583 9.54882 13.8417 9.54882 13.6464 9.35355L12.5 8.20711L11.3536 9.35355C11.1583 9.54882 10.8417 9.54882 10.6464 9.35355C10.4512 9.15829 10.4512 8.84171 10.6464 8.64645L11.7929 7.5L10.6464 6.35355C10.4512 6.15829 10.4512 5.84171 10.6464 5.64645Z"
      fill="currentColor"
    />
  </svg>
)

export const CaretHorizontal: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5682 4.93179C9.39246 4.75605 9.10754 4.75605 8.9318 4.93179C8.75607 5.10753 8.75607 5.39245 8.9318 5.56819L10.8636 7.49999L8.9318 9.43179C8.75607 9.60753 8.75607 9.89245 8.9318 10.0682C9.10754 10.2439 9.39246 10.2439 9.5682 10.0682L11.8182 7.81819C11.9026 7.73379 11.95 7.61933 11.95 7.49999C11.95 7.38064 11.9026 7.26618 11.8182 7.18179L9.5682 4.93179ZM5.4318 10.0682C5.60754 10.2439 5.89246 10.2439 6.0682 10.0682C6.24393 9.89245 6.24393 9.60753 6.0682 9.43179L4.13639 7.49999L6.0682 5.56819C6.24393 5.39245 6.24393 5.10753 6.0682 4.93179C5.89246 4.75605 5.60754 4.75605 5.4318 4.93179L3.18179 7.18179C3.00609 7.35753 3.00609 7.64245 3.18179 7.81819L5.4318 10.0682Z"
      fill="currentColor"
    />
  </svg>
)

export const CloudChecked: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.35362 7.04489L3.67822 7.16256C3.16491 7.25198 2.71388 7.52141 2.40857 7.90658C2.10419 8.29056 1.96444 8.76339 2.00771 9.23275C2.05102 9.70246 2.27585 10.148 2.65009 10.4783C3.02517 10.8093 3.52215 10.9987 4.04462 11H10.9554C11.4778 10.9987 11.9748 10.8093 12.3499 10.4783C12.7242 10.148 12.949 9.70246 12.9923 9.23275C13.0356 8.76339 12.8958 8.29056 12.5914 7.90658C12.2861 7.52141 11.8351 7.25198 11.3218 7.16256L10.6465 7.04491L10.5127 6.37264C10.4001 5.80752 10.1129 5.2823 9.68158 4.86724C9.24998 4.45194 8.69414 4.16663 8.08401 4.05401C7.8921 4.01902 7.69713 4.00092 7.50158 4C6.77822 3.9998 6.08226 4.24247 5.53306 4.679C4.9842 5.11526 4.61802 5.71573 4.48738 6.3725L4.35362 7.04489ZM7.50407 3C6.55761 2.99925 5.64052 3.31617 4.91082 3.89617C4.18113 4.47617 3.68453 5.28292 3.50659 6.17739C2.75766 6.30787 2.08649 6.70308 1.6249 7.28539C1.16332 7.86771 0.944683 8.59505 1.01194 9.32455C1.07919 10.0541 1.42747 10.733 1.98838 11.228C2.54929 11.7231 3.28228 11.9984 4.04339 12H10.9566C11.7177 11.9984 12.4507 11.7231 13.0116 11.228C13.5725 10.733 13.9208 10.0541 13.9881 9.32455C14.0553 8.59505 13.8367 7.86771 13.3751 7.28539C12.9135 6.70308 12.2423 6.30787 11.4934 6.17739C11.3402 5.40802 10.9506 4.70059 10.3749 4.14666C9.79928 3.59274 9.06409 3.21782 8.26452 3.07044C8.01381 3.02465 7.75925 3.00108 7.50407 3Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.35355 6.64645C9.54882 6.84171 9.54882 7.15829 9.35355 7.35355L7.35355 9.35355C7.15829 9.54882 6.84171 9.54882 6.64645 9.35355L5.64645 8.35355C5.45118 8.15829 5.45118 7.84171 5.64645 7.64645C5.84171 7.45119 6.15829 7.45119 6.35355 7.64645L7 8.29289L8.64645 6.64645C8.84171 6.45119 9.15829 6.45119 9.35355 6.64645Z"
      fill="currentColor"
    />
  </svg>
)

export const CloudError: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.14645 6.64645C6.34171 6.45119 6.65829 6.45119 6.85355 6.64645L7.5 7.29289L8.14645 6.64645C8.34171 6.45119 8.65829 6.45119 8.85355 6.64645C9.04882 6.84171 9.04882 7.15829 8.85355 7.35355L8.20711 8L8.85355 8.64645C9.04882 8.84171 9.04882 9.15829 8.85355 9.35355C8.65829 9.54882 8.34171 9.54882 8.14645 9.35355L7.5 8.70711L6.85355 9.35355C6.65829 9.54882 6.34171 9.54882 6.14645 9.35355C5.95118 9.15829 5.95118 8.84171 6.14645 8.64645L6.79289 8L6.14645 7.35355C5.95118 7.15829 5.95118 6.84171 6.14645 6.64645Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.50407 3C6.55761 2.99925 5.64052 3.31617 4.91082 3.89617C4.18113 4.47617 3.68453 5.28292 3.50659 6.1774C2.75766 6.30787 2.08649 6.70308 1.6249 7.28539C1.16332 7.86771 0.944683 8.59505 1.01194 9.32455C1.07919 10.0541 1.42747 10.733 1.98838 11.228C2.54929 11.7231 3.28228 11.9984 4.04339 12H10.9566C11.7177 11.9984 12.4507 11.7231 13.0116 11.228C13.5725 10.733 13.9208 10.0541 13.9881 9.32455C14.0553 8.59505 13.8367 7.86771 13.3751 7.28539C12.9135 6.70308 12.2423 6.30787 11.4934 6.1774C11.3402 5.40802 10.9506 4.70059 10.3749 4.14666C9.79928 3.59274 9.06409 3.21782 8.26452 3.07044C8.01381 3.02465 7.75925 3.00108 7.50407 3ZM4.35362 7.04489L3.67822 7.16256C3.16491 7.25198 2.71388 7.52141 2.40857 7.90658C2.10419 8.29056 1.96444 8.7634 2.00771 9.23275C2.05102 9.70246 2.27585 10.148 2.65009 10.4783C3.02517 10.8093 3.52215 10.9987 4.04462 11H10.9554C11.4778 10.9987 11.9748 10.8093 12.3499 10.4783C12.7242 10.148 12.949 9.70246 12.9923 9.23275C13.0356 8.7634 12.8958 8.29056 12.5914 7.90658C12.2861 7.52141 11.8351 7.25198 11.3218 7.16256L10.6465 7.04491L10.5127 6.37264C10.4001 5.80752 10.1129 5.2823 9.68158 4.86724C9.24998 4.45194 8.69414 4.16663 8.08401 4.05401C7.8921 4.01902 7.69713 4.00093 7.50158 4C6.77822 3.9998 6.08226 4.24247 5.53306 4.67901C4.9842 5.11526 4.61802 5.71573 4.48738 6.3725L4.35362 7.04489Z"
      fill="currentColor"
    />
  </svg>
)

export const SoloOff: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 13C10.5376 13 13 10.5376 13 7.5C13 4.46243 10.5376 2 7.5 2C4.46243 2 2 4.46243 2 7.5C2 10.5376 4.46243 13 7.5 13ZM7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1C3.91015 1 1 3.91015 1 7.5C1 11.0899 3.91015 14 7.5 14Z"
      fill="black"
    />
    <path
      d="M5.18408 9.25781C5.18408 9.5083 5.3335 9.77637 5.61035 10.0312C6.00586 10.4048 6.6958 10.6201 7.47363 10.6201C8.90625 10.6201 9.81592 9.89502 9.81592 8.75244C9.81592 7.86914 9.29736 7.3374 8.19873 7.08691L7.29785 6.87158C6.73975 6.74414 6.46729 6.48047 6.46729 6.10693C6.46729 5.64111 6.86719 5.34229 7.49121 5.34229C8.00977 5.34229 8.41406 5.56641 8.68213 5.96631C8.82275 6.14209 8.98096 6.22119 9.16553 6.22119C9.45117 6.22119 9.64453 6.03223 9.64453 5.75537C9.64453 5.47852 9.49951 5.19727 9.22705 4.95117C8.83154 4.58643 8.18994 4.37988 7.47363 4.37988C6.1377 4.37988 5.26758 5.09619 5.26758 6.19922C5.26758 7.06934 5.78174 7.61865 6.81445 7.85596L7.71094 8.07568C8.36133 8.22949 8.64258 8.47998 8.64258 8.88428C8.64258 9.37207 8.24268 9.65332 7.53955 9.65332C7.0166 9.65332 6.56836 9.45117 6.22998 9.06006C6.01904 8.83154 5.85645 8.74805 5.65869 8.74805C5.39062 8.74805 5.18408 8.95898 5.18408 9.25781Z"
      fill="currentColor"
    />
  </svg>
)

export const SoloOn: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1C3.91015 1 1 3.91015 1 7.5C1 11.0899 3.91015 14 7.5 14ZM5.61035 10.0312C5.3335 9.77637 5.18408 9.5083 5.18408 9.25781C5.18408 8.95898 5.39062 8.74805 5.65869 8.74805C5.85645 8.74805 6.01904 8.83154 6.22998 9.06006C6.56836 9.45117 7.0166 9.65332 7.53955 9.65332C8.24268 9.65332 8.64258 9.37207 8.64258 8.88428C8.64258 8.47998 8.36133 8.22949 7.71094 8.07568L6.81445 7.85596C5.78174 7.61865 5.26758 7.06934 5.26758 6.19922C5.26758 5.09619 6.1377 4.37988 7.47363 4.37988C8.18994 4.37988 8.83154 4.58643 9.22705 4.95117C9.49951 5.19727 9.64453 5.47852 9.64453 5.75537C9.64453 6.03223 9.45117 6.22119 9.16553 6.22119C8.98096 6.22119 8.82275 6.14209 8.68213 5.96631C8.41406 5.56641 8.00977 5.34229 7.49121 5.34229C6.86719 5.34229 6.46729 5.64111 6.46729 6.10693C6.46729 6.48047 6.73975 6.74414 7.29785 6.87158L8.19873 7.08691C9.29736 7.3374 9.81592 7.86914 9.81592 8.75244C9.81592 9.89502 8.90625 10.6201 7.47363 10.6201C6.6958 10.6201 6.00586 10.4048 5.61035 10.0312Z"
      fill="currentColor"
    />
  </svg>
)

export const Randomize: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.68748 3.5L3.12498 4.375L3.99998 2.8125L3.12498 1.25L4.68748 2.125L6.24997 1.25L5.37498 2.8125L6.24997 4.375L4.68748 3.5ZM12.1875 9.625L13.75 8.75L12.875 10.3125L13.75 11.875L12.1875 11L10.625 11.875L11.5 10.3125L10.625 8.75L12.1875 9.625ZM13.75 1.25L12.875 2.8125L13.75 4.375L12.1875 3.5L10.625 4.375L11.5 2.8125L10.625 1.25L12.1875 2.125L13.75 1.25ZM8.33747 7.9875L9.86247 6.4625L8.53747 5.1375L7.01247 6.6625L8.33747 7.9875ZM8.98122 4.55625L10.4437 6.01875C10.6875 6.25 10.6875 6.65625 10.4437 6.9L3.14998 14.1937C2.90623 14.4375 2.49998 14.4375 2.26873 14.1937L0.806226 12.7312C0.562476 12.5 0.562476 12.0937 0.806226 11.85L8.09997 4.55625C8.34372 4.3125 8.74997 4.3125 8.98122 4.55625Z"
      fill="currentColor"
    />
  </svg>
)

export const DiceCube: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.85593 8.98326C3.96313 9.38336 4.26627 9.64977 4.533 9.5783C4.79974 9.50683 4.92906 9.12454 4.82185 8.72444C4.71464 8.32434 4.41151 8.05794 4.14477 8.12941C3.87804 8.20088 3.74872 8.58316 3.85593 8.98326Z"
      fill="currentColor"
    />
    <path
      d="M5.49411 11.3332C5.60132 11.7333 5.90445 11.9997 6.17119 11.9283C6.43792 11.8568 6.56724 11.4745 6.46003 11.0744C6.35283 10.6743 6.04969 10.4079 5.78296 10.4794C5.51622 10.5509 5.3869 10.9331 5.49411 11.3332Z"
      fill="currentColor"
    />
    <path
      d="M2.49411 6.73326C2.60132 7.13336 2.90445 7.39977 3.17119 7.3283C3.43792 7.25683 3.56724 6.87454 3.46003 6.47444C3.35283 6.07434 3.04969 5.80794 2.78296 5.87941C2.51622 5.95088 2.3869 6.33316 2.49411 6.73326Z"
      fill="currentColor"
    />
    <path
      d="M11.1599 8.98326C11.0527 9.38336 10.7496 9.64977 10.4829 9.5783C10.2161 9.50683 10.0868 9.12454 10.194 8.72444C10.3012 8.32434 10.6044 8.05794 10.8711 8.12941C11.1378 8.20088 11.2671 8.58316 11.1599 8.98326Z"
      fill="currentColor"
    />
    <path
      d="M9.52176 7.98326C9.41455 8.38336 9.11141 8.64977 8.84468 8.5783C8.57795 8.50683 8.44862 8.12454 8.55583 7.72444C8.66304 7.32434 8.96618 7.05794 9.23291 7.12941C9.49964 7.20088 9.62896 7.58316 9.52176 7.98326Z"
      fill="currentColor"
    />
    <path
      d="M9.52176 11.3332C9.41455 11.7333 9.11141 11.9997 8.84468 11.9283C8.57795 11.8568 8.44862 11.4745 8.55583 11.0744C8.66304 10.6743 8.96618 10.4079 9.23291 10.4794C9.49964 10.5509 9.62896 10.9331 9.52176 11.3332Z"
      fill="currentColor"
    />
    <path
      d="M12.5218 6.73326C12.4146 7.13336 12.1114 7.39977 11.8447 7.3283C11.5779 7.25683 11.4486 6.87454 11.5558 6.47444C11.663 6.07434 11.9662 5.80794 12.2329 5.87941C12.4996 5.95088 12.629 6.33316 12.5218 6.73326Z"
      fill="currentColor"
    />
    <path
      d="M12.5218 10.0832C12.4146 10.4833 12.1114 10.7497 11.8447 10.6783C11.5779 10.6068 11.4486 10.2245 11.5558 9.82442C11.663 9.42432 11.9662 9.15791 12.2329 9.22939C12.4996 9.30086 12.629 9.68314 12.5218 10.0832Z"
      fill="currentColor"
    />
    <path
      d="M8.49995 3.93915C8.49995 4.21529 8.05223 4.43915 7.49995 4.43915C6.94766 4.43915 6.49995 4.21529 6.49995 3.93915C6.49995 3.66301 6.94766 3.43915 7.49995 3.43915C8.05223 3.43915 8.49995 3.66301 8.49995 3.93915Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.71144 0.796908C7.57742 0.734364 7.42258 0.734364 7.28856 0.796908L1.28856 3.59691C1.11252 3.67906 1 3.85574 1 4.05V10.95C1 11.1443 1.11252 11.3209 1.28856 11.4031L7.28856 14.2031C7.42258 14.2656 7.57742 14.2656 7.71144 14.2031L13.7114 11.4031C13.8875 11.3209 14 11.1443 14 10.95V4.05C14 3.85574 13.8875 3.67906 13.7114 3.59691L7.71144 0.796908ZM7 6.93078L2 4.80578V10.6316L7 12.9649V6.93078ZM13 10.6316L8 12.9649V6.93078L13 4.80578V10.6316ZM12.2719 4.02866L7.5 6.05672L2.72809 4.02866L7.5 1.80176L12.2719 4.02866Z"
      fill="currentColor"
    />
  </svg>
)

export const ZoomIn: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5ZM9.30884 10.0159C8.53901 10.6318 7.56251 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 7.56251 10.6318 8.53901 10.0159 9.30884L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L9.30884 10.0159ZM4.25 6.5C4.25 6.22386 4.47386 6 4.75 6H6V4.75C6 4.47386 6.22386 4.25 6.5 4.25C6.77614 4.25 7 4.47386 7 4.75V6H8.25C8.52614 6 8.75 6.22386 8.75 6.5C8.75 6.77614 8.52614 7 8.25 7H7V8.25C7 8.52614 6.77614 8.75 6.5 8.75C6.22386 8.75 6 8.52614 6 8.25V7H4.75C4.47386 7 4.25 6.77614 4.25 6.5Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    ></path>
  </svg>
)

export const ZoomOut: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.5 10C8.433 10 10 8.433 10 6.5C10 4.567 8.433 3 6.5 3C4.567 3 3 4.567 3 6.5C3 8.433 4.567 10 6.5 10ZM6.5 11C7.56251 11 8.53901 10.6318 9.30884 10.0159L12.1464 12.8536C12.3417 13.0488 12.6583 13.0488 12.8536 12.8536C13.0488 12.6583 13.0488 12.3417 12.8536 12.1464L10.0159 9.30884C10.6318 8.53901 11 7.56251 11 6.5C11 4.01472 8.98528 2 6.5 2C4.01472 2 2 4.01472 2 6.5C2 8.98528 4.01472 11 6.5 11ZM4.75 6C4.47386 6 4.25 6.22386 4.25 6.5C4.25 6.77614 4.47386 7 4.75 7H8.25C8.52614 7 8.75 6.77614 8.75 6.5C8.75 6.22386 8.52614 6 8.25 6H4.75Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    ></path>
  </svg>
)

export const CopyClipboard: FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 8.5C0 9.32844 0.67157 10 1.5 10H3V9.00004H1.5C1.22386 9.00004 1 8.77614 1 8.5V1.5C1 1.22386 1.22386 1 1.5 1H8.5C8.77614 1 9 1.22386 9 1.5V2.99996H4.5C3.67158 2.99996 3 3.67153 3 4.49996V11.4999C3 12.3283 3.67158 12.9999 4.5 12.9999H11.5C12.3284 12.9999 13 12.3283 13 11.4999V4.49996C13 3.67153 12.3284 2.99996 11.5 2.99996H10V1.5C10 0.67157 9.3284 0 8.5 0H1.5C0.67157 0 0 0.67157 0 1.5V8.5ZM4 4.49996C4 4.22382 4.22386 3.99996 4.5 3.99996H11.5C11.7761 3.99996 12 4.22382 12 4.49996V11.4999C12 11.7761 11.7761 11.9999 11.5 11.9999H4.5C4.22386 11.9999 4 11.7761 4 11.4999V4.49996Z"
      fill="black"
    />
  </svg>
)

export const Metronome: FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M1.72361 13.5528L7.10557 2.78885C7.4741 2.05181 8.5259 2.05181 8.89443 2.78886L14.2764 13.5528C14.6088 14.2177 14.1253 15 13.382 15H2.61803C1.87465 15 1.39116 14.2177 1.72361 13.5528Z"
      stroke="currentColor"
      strokeWidth="1.3"
    />
    <path d="M2.86664 11.7692L13.1333 11.7692" stroke="currentColor" strokeWidth="1.3" />
    <path
      d="M7.53345 11.7692L12.6668 1"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
  </svg>
)

export const User: FC<IconProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 142 140" fill="none" {...props}>
    <circle cx="69.5" cy="51.5" r="15.5" fill="#E8E6DB" />
    <path
      d="M102 107C102 102.798 101.159 98.6365 99.5261 94.7541C97.8928 90.8717 95.4989 87.3441 92.481 84.3726C89.4631 81.4011 85.8803 79.044 81.9372 77.4359C77.9941 75.8277 73.768 75 69.5 75C65.232 75 61.0059 75.8277 57.0628 77.4359C53.1197 79.044 49.5369 81.4011 46.519 84.3726C43.5011 87.3441 41.1072 90.8717 39.4739 94.7541C37.8406 98.6365 37 102.798 37 107L102 107Z"
      fill="#E8E6DB"
    />
  </svg>
)

export const PlusOutlined: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM7.50003 4C7.77617 4 8.00003 4.22386 8.00003 4.5V7H10.5C10.7762 7 11 7.22386 11 7.5C11 7.77614 10.7762 8 10.5 8H8.00003V10.5C8.00003 10.7761 7.77617 11 7.50003 11C7.22389 11 7.00003 10.7761 7.00003 10.5V8H4.50003C4.22389 8 4.00003 7.77614 4.00003 7.5C4.00003 7.22386 4.22389 7 4.50003 7H7.00003V4.5C7.00003 4.22386 7.22389 4 7.50003 4Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    ></path>
  </svg>
)

export const DotsVertical: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.625 2.5C8.625 3.12132 8.12132 3.625 7.5 3.625C6.87868 3.625 6.375 3.12132 6.375 2.5C6.375 1.87868 6.87868 1.375 7.5 1.375C8.12132 1.375 8.625 1.87868 8.625 2.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM7.5 13.625C8.12132 13.625 8.625 13.1213 8.625 12.5C8.625 11.8787 8.12132 11.375 7.5 11.375C6.87868 11.375 6.375 11.8787 6.375 12.5C6.375 13.1213 6.87868 13.625 7.5 13.625Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    ></path>
  </svg>
)

export const SoundIcon: FC<IconProps> = (props) => (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="38"
      viewBox="0 0 42 38"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7481 2.04669C22.7481 1.09162 21.9738 0.317387 21.0188 0.317386C20.0637 0.317386 19.2895 1.09162 19.2895 2.04669L19.2895 36.1985C19.2895 37.1536 20.0637 37.9278 21.0188 37.9278C21.9738 37.9278 22.7481 37.1536 22.7481 36.1985L22.7481 2.04669ZM11.5322 7.90676C12.4873 7.90676 13.2615 8.681 13.2615 9.63607L13.2615 28.6093C13.2615 29.5644 12.4873 30.3386 11.5322 30.3386C10.5772 30.3386 9.80294 29.5644 9.80294 28.6093L9.80294 9.63607C9.80294 8.681 10.5772 7.90676 11.5322 7.90676ZM2.04571 15.4961C3.00077 15.4961 3.77501 16.2704 3.77501 17.2254L3.77501 21.0201C3.77501 21.9752 3.00077 22.7494 2.04571 22.7494C1.09064 22.7494 0.316402 21.9752 0.316403 21.0201L0.316403 17.2254C0.316403 16.2704 1.09064 15.4961 2.04571 15.4961ZM30.5053 7.90676C31.4604 7.90676 32.2346 8.681 32.2346 9.63607L32.2346 28.6093C32.2346 29.5644 31.4604 30.3386 30.5053 30.3386C29.5502 30.3386 28.776 29.5644 28.776 28.6093L28.776 9.63607C28.776 8.681 29.5502 7.90676 30.5053 7.90676ZM41.7221 17.2254C41.7221 16.2704 40.9479 15.4961 39.9928 15.4961C39.0378 15.4961 38.2635 16.2704 38.2635 17.2254L38.2635 21.0201C38.2635 21.9752 39.0378 22.7494 39.9928 22.7494C40.9479 22.7494 41.7221 21.9752 41.7221 21.0201L41.7221 17.2254Z"
        fill="currentColor"
      />
    </svg>
    {/* <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="7" y="1.5" width="1" height="12" rx="0.5" fill="currentColor" />
      <rect x="10" y="3.5" width="1" height="8" rx="0.5" fill="currentColor" />
      <rect x="13" y="6.5" width="1" height="2" rx="0.5" fill="currentColor" />
      <rect x="4" y="3.5" width="1" height="8" rx="0.5" fill="currentColor" />
      <rect x="1" y="6.5" width="1" height="2" rx="0.5" fill="currentColor" />
    </svg> */}
  </>
)

export const UploadFileIcon: FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    enableBackground="new 0 0 24 24"
    height="24px"
    viewBox="0 0 24 24"
    width="24px"
    fill="#FFFFFF"
    {...props}
  >
    <g>
      <rect fill="none" height="24" width="24" />
    </g>
    <g>
      <path d="M18,15v3H6v-3H4v3c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-3H18z M7,9l1.41,1.41L11,7.83V16h2V7.83l2.59,2.58L17,9l-5-5L7,9z" />
    </g>
  </svg>
)

export const ShareIcon: FC<IconProps> = (props) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 14.1724L5 14.1957L5 14.1958C4.99999 14.6049 4.99999 14.9463 5.02278 15.2253C5.04655 15.5163 5.09795 15.7894 5.22957 16.0477C5.4315 16.444 5.75371 16.7663 6.15002 16.9682C6.40833 17.0998 6.68149 17.1512 6.97245 17.175C7.2514 17.1978 7.59285 17.1978 8.00193 17.1978L8.002 17.1978L8.02531 17.1978L12.7756 17.1978L12.799 17.1978L12.799 17.1978C13.2081 17.1978 13.5495 17.1978 13.8285 17.175C14.1195 17.1512 14.3926 17.0998 14.6509 16.9682C15.0472 16.7663 15.3695 16.444 15.5714 16.0477C15.703 15.7894 15.7544 15.5163 15.7782 15.2253C15.801 14.9463 15.801 14.6049 15.8009 14.1958L15.8009 14.1724L15.8009 11.2449L15.8009 11.2216C15.801 10.8125 15.801 10.471 15.7782 10.192C15.7544 9.90109 15.703 9.62792 15.5714 9.36961C15.3694 8.9733 15.0472 8.65109 14.6509 8.44916C14.3926 8.31754 14.1194 8.26615 13.8285 8.24238C13.5495 8.21959 13.208 8.2196 12.7989 8.21961L12.7756 8.21961L12.5721 8.21962L12.572 8.21962L12.331 8.21958C12.0137 8.21953 11.7565 8.47666 11.7565 8.79391C11.7564 9.11116 12.0136 9.36838 12.3308 9.36843L12.5719 9.36847L12.572 9.36847L12.7756 9.36847C13.214 9.36846 13.5083 9.3689 13.7349 9.38741C13.9548 9.40538 14.06 9.43746 14.1294 9.4728C14.3095 9.56458 14.456 9.71104 14.5477 9.89119C14.5831 9.96055 14.6152 10.0657 14.6331 10.2856C14.6517 10.5122 14.6521 10.8065 14.6521 11.2449L14.6521 14.1724C14.6521 14.6109 14.6517 14.9051 14.6331 15.1318C14.6152 15.3517 14.5831 15.4568 14.5478 15.5262C14.456 15.7063 14.3095 15.8528 14.1294 15.9446C14.06 15.9799 13.9549 16.012 13.7349 16.0299C13.5083 16.0485 13.2141 16.0489 12.7756 16.0489L8.02531 16.0489C7.58689 16.0489 7.29262 16.0485 7.066 16.0299C6.84609 16.012 6.74095 15.9799 6.67159 15.9446C6.49145 15.8528 6.34499 15.7063 6.2532 15.5262C6.21786 15.4568 6.18578 15.3517 6.16781 15.1317C6.1493 14.9051 6.14885 14.6109 6.14885 14.1724L6.14885 11.2449C6.14885 10.8065 6.1493 10.5122 6.16781 10.2856C6.18578 10.0657 6.21786 9.96053 6.2532 9.89117C6.34499 9.71102 6.49145 9.56456 6.67159 9.47278C6.74095 9.43744 6.84609 9.40536 7.066 9.38739C7.29262 9.36888 7.58689 9.36843 8.02531 9.36843L8.22852 9.36843L8.47006 9.36843C8.7873 9.36843 9.04448 9.11125 9.04448 8.794C9.04448 8.47676 8.7873 8.21958 8.47006 8.21958L8.22852 8.21958L8.02531 8.21958L8.00197 8.21958C7.59288 8.21957 7.25141 8.21956 6.97245 8.24236C6.68149 8.26613 6.40833 8.31753 6.15002 8.44914C5.75371 8.65107 5.4315 8.97329 5.22957 9.3696C5.09795 9.62791 5.04655 9.90107 5.02278 10.192C4.99999 10.471 4.99999 10.8125 5 11.2216L5 11.2216L5 11.2449L5 14.1724ZM7.24792 5.76688C7.0175 5.98494 7.00748 6.34851 7.22554 6.57893C7.4436 6.80935 7.80717 6.81938 8.03759 6.60132L9.82607 4.9088L9.82607 12.0561C9.82607 12.3733 10.0833 12.6305 10.4005 12.6305C10.7177 12.6305 10.9749 12.3733 10.9749 12.0561L10.9749 4.9088L12.7634 6.60132C12.9938 6.81938 13.3574 6.80935 13.5755 6.57893C13.7935 6.34851 13.7835 5.98494 13.5531 5.76688L10.7953 3.1571C10.5738 2.9475 10.2272 2.9475 10.0057 3.1571L7.24792 5.76688Z"
      fill="#707070"
    />
  </svg>
)

export const ChevronDownIcon: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    ></path>
  </svg>
)

export const BookOpenIcon: FC<IconProps> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.3104 1.1505C7.56335 1.37017 8.70772 1.79125 10.0003 2.56845C11.2929 1.79125 12.4373 1.37017 13.6903 1.1505C15.0279 0.915976 16.4732 0.915993 18.2807 0.916016L18.3337 0.916016C18.7479 0.916016 19.0837 1.2518 19.0837 1.66602V10.8136V10.8417C19.0837 11.2325 19.0837 11.5689 19.0618 11.8456C19.0387 12.1367 18.9878 12.427 18.8491 12.7066C18.6394 13.129 18.3189 13.461 17.9041 13.6854C17.6261 13.8357 17.3296 13.8959 17.0335 13.9289C16.7488 13.9607 16.3986 13.973 15.9875 13.9874L15.9874 13.9874L15.9596 13.9884C13.8067 14.064 12.3725 14.366 10.4059 15.6302C10.1588 15.7891 9.84181 15.7891 9.59476 15.6302C7.62813 14.366 6.194 14.064 4.04109 13.9884L4.01325 13.9874L4.0132 13.9874C3.60208 13.973 3.25184 13.9607 2.96716 13.9289C2.67108 13.8959 2.37457 13.8357 2.09656 13.6854C1.68179 13.461 1.36123 13.129 1.15158 12.7066C1.01283 12.427 0.961947 12.1367 0.938884 11.8456C0.916969 11.5689 0.91698 11.2326 0.916992 10.8418L0.916993 10.8136V1.66602C0.916993 1.4671 0.99601 1.27634 1.13666 1.13569C1.27732 0.995034 1.46808 0.916016 1.66699 0.916016L1.72 0.916016H1.72C3.52749 0.915994 4.97276 0.915977 6.3104 1.1505ZM6.05136 2.62796C7.11199 2.81392 8.09015 3.16699 9.25033 3.86778V13.6964C7.52944 12.8076 6.02734 12.5572 4.09374 12.4893C3.64718 12.4736 3.35451 12.4628 3.13337 12.4382C2.91722 12.4141 2.84159 12.383 2.81018 12.366C2.66771 12.2889 2.5672 12.1848 2.49519 12.0397C2.47755 12.0042 2.45023 11.9296 2.4342 11.7271C2.41754 11.5168 2.41699 11.2405 2.41699 10.8136V2.4167C3.90257 2.42068 5.02208 2.4475 6.05136 2.62796ZM15.9069 12.4893C13.9733 12.5572 12.4712 12.8076 10.7503 13.6964V3.86778C11.9105 3.16699 12.8887 2.81392 13.9493 2.62796C14.9786 2.4475 16.0981 2.42068 17.5837 2.4167V10.8136C17.5837 11.2405 17.5831 11.5168 17.5665 11.7271C17.5504 11.9296 17.5231 12.0042 17.5055 12.0397C17.4335 12.1848 17.3329 12.2889 17.1905 12.366C17.1591 12.383 17.0834 12.4141 16.8673 12.4382C16.6461 12.4628 16.3535 12.4736 15.9069 12.4893ZM2.50033 15.4993C2.08611 15.4993 1.75033 15.8351 1.75033 16.2493C1.75033 16.6636 2.08611 16.9993 2.50033 16.9993C4.14076 16.9993 5.31386 17.1028 6.36549 17.3896C7.40922 17.6742 8.37655 18.1516 9.5843 18.9567C9.83623 19.1247 10.1644 19.1247 10.4164 18.9567C11.6241 18.1516 12.5914 17.6742 13.6352 17.3896C14.6868 17.1028 15.8599 16.9993 17.5003 16.9993C17.9145 16.9993 18.2503 16.6636 18.2503 16.2493C18.2503 15.8351 17.9145 15.4993 17.5003 15.4993C15.8074 15.4993 14.4805 15.6043 13.2405 15.9424C12.1284 16.2458 11.121 16.727 10.0003 17.4379C8.87964 16.727 7.87229 16.2458 6.76016 15.9424C5.52012 15.6043 4.19323 15.4993 2.50033 15.4993Z"
      fill="currentColor"
    />
  </svg>
)

export const PlaylistIcon: FC<IconProps> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.916992 3.33398C0.916992 2.91977 1.25278 2.58398 1.66699 2.58398H16.667C17.0812 2.58398 17.417 2.91977 17.417 3.33398C17.417 3.7482 17.0812 4.08398 16.667 4.08398H1.66699C1.25278 4.08398 0.916992 3.7482 0.916992 3.33398ZM16.2497 8.54328C16.0195 8.38985 15.7236 8.37555 15.4798 8.50606C15.2359 8.63658 15.0837 8.89072 15.0837 9.16732V13.5972C14.801 13.4813 14.4915 13.4173 14.167 13.4173C12.8323 13.4173 11.7503 14.4993 11.7503 15.834C11.7503 17.1687 12.8323 18.2507 14.167 18.2507C15.5009 18.2507 16.5823 17.17 16.5837 15.8364L16.5837 15.834V10.5687L17.9176 11.458C18.2623 11.6878 18.7279 11.5947 18.9577 11.25C19.1875 10.9054 19.0943 10.4397 18.7497 10.2099L16.2497 8.54328ZM15.0837 15.834C15.0837 15.3277 14.6733 14.9173 14.167 14.9173C13.6607 14.9173 13.2503 15.3277 13.2503 15.834C13.2503 16.3402 13.6607 16.7507 14.167 16.7507C14.6733 16.7507 15.0837 16.3402 15.0837 15.834ZM1.66699 6.75065C1.25278 6.75065 0.916992 7.08644 0.916992 7.50065C0.916992 7.91486 1.25278 8.25065 1.66699 8.25065H13.3337C13.7479 8.25065 14.0837 7.91486 14.0837 7.50065C14.0837 7.08644 13.7479 6.75065 13.3337 6.75065H1.66699ZM0.916992 11.6673C0.916992 11.2531 1.25278 10.9173 1.66699 10.9173H10.0003C10.4145 10.9173 10.7503 11.2531 10.7503 11.6673C10.7503 12.0815 10.4145 12.4173 10.0003 12.4173H1.66699C1.25278 12.4173 0.916992 12.0815 0.916992 11.6673ZM1.66699 15.084C1.25278 15.084 0.916992 15.4198 0.916992 15.834C0.916992 16.2482 1.25278 16.584 1.66699 16.584H7.50033C7.91454 16.584 8.25033 16.2482 8.25033 15.834C8.25033 15.4198 7.91454 15.084 7.50033 15.084H1.66699Z"
      fill="currentColor"
    />
  </svg>
)

export const FireIcon: FC<IconProps> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.816 8.12548C13.3276 7.75067 12.8616 7.34918 12.4759 6.88244C10.2816 4.22805 11.4184 2 11.4184 2C7.34519 3.58789 6.41753 6.10833 6.37346 7.98532L6.37563 8.00524C6.37563 8.00524 6.41123 9.08107 6.93093 10.2636C7.09361 10.6337 6.91224 11.0666 6.49896 11.1781C6.15728 11.2702 5.80616 11.1139 5.66178 10.8228C5.42809 10.3513 5.11946 9.60153 5.20818 9.07266C4.56298 9.86688 4.13613 10.8329 4.02656 11.9043C3.73819 14.7217 5.82819 17.3366 8.81557 17.89C12.243 18.5249 15.4841 16.3405 15.9452 13.1726C16.2338 11.1903 15.3623 9.31187 13.816 8.12548ZM11.7683 14.174C11.7467 14.2007 11.192 14.8434 10.2625 14.9103C10.2122 14.9125 10.1593 14.9147 10.1089 14.9147C9.46765 14.9147 8.81695 14.6314 8.17077 14.0691L8.02914 13.9463L8.20932 13.8816C8.22132 13.8772 9.45565 13.4354 9.75838 12.4783C9.86166 12.1549 9.82802 11.7866 9.66475 11.4431C9.46785 11.0237 9.0884 9.9683 9.80894 9.20296L9.94821 9.05566L10.0155 9.24079C10.0178 9.25193 10.4526 10.4299 11.4805 11.0458C11.7904 11.2333 12.0233 11.4608 12.1698 11.7196C12.4719 12.2641 12.6498 13.132 11.7683 14.174Z"
      fill="currentColor"
    />
  </svg>
)

export const TrendUpIcon: FC<IconProps> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 7C15.4477 7 15 6.55228 15 6C15 5.44772 15.4477 5 16 5H22C22.5523 5 23 5.44772 23 6V12C23 12.5523 22.5523 13 22 13C21.4477 13 21 12.5523 21 12V8.41421L15.6439 13.7703L15.6175 13.7967C15.3011 14.1131 15.0222 14.392 14.7724 14.6041C14.5068 14.8296 14.209 15.0376 13.838 15.1582C13.2934 15.3351 12.7066 15.3351 12.162 15.1582C11.791 15.0376 11.4932 14.8296 11.2276 14.6041C10.9778 14.392 10.6988 14.1131 10.3824 13.7966L10.3561 13.7703L10.2297 13.6439C9.87904 13.2933 9.65803 13.0733 9.47806 12.9206C9.30701 12.7754 9.23985 12.7504 9.21997 12.7439C9.07698 12.6975 8.92296 12.6975 8.77997 12.7439C8.76009 12.7504 8.69293 12.7754 8.52188 12.9206C8.34191 13.0733 8.1209 13.2933 7.77026 13.6439L2.70711 18.707C2.31658 19.0976 1.68342 19.0976 1.29289 18.707C0.902369 18.3165 0.902369 17.6834 1.29289 17.2928L6.35604 12.2297L6.38239 12.2033C6.69881 11.8869 6.97772 11.608 7.22753 11.3959C7.49318 11.1704 7.79095 10.9623 8.16194 10.8418C8.70661 10.6648 9.29333 10.6648 9.838 10.8418C10.209 10.9623 10.5068 11.1704 10.7724 11.3959C11.0222 11.6079 11.3011 11.8869 11.6175 12.2033L11.6439 12.2297L11.7703 12.3561C12.1209 12.7067 12.3419 12.9266 12.5219 13.0794C12.693 13.2246 12.7601 13.2496 12.78 13.2561C12.923 13.3025 13.077 13.3025 13.22 13.2561C13.2399 13.2496 13.307 13.2246 13.4781 13.0794C13.6581 12.9266 13.8791 12.7067 14.2297 12.3561L19.5858 7H16Z"
      fill="currentColor"
    />
  </svg>
)

export const ClockIcon: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.50009 0.877014C3.84241 0.877014 0.877258 3.84216 0.877258 7.49984C0.877258 11.1575 3.8424 14.1227 7.50009 14.1227C11.1578 14.1227 14.1229 11.1575 14.1229 7.49984C14.1229 3.84216 11.1577 0.877014 7.50009 0.877014ZM1.82726 7.49984C1.82726 4.36683 4.36708 1.82701 7.50009 1.82701C10.6331 1.82701 13.1729 4.36683 13.1729 7.49984C13.1729 10.6328 10.6331 13.1727 7.50009 13.1727C4.36708 13.1727 1.82726 10.6328 1.82726 7.49984ZM8 4.50001C8 4.22387 7.77614 4.00001 7.5 4.00001C7.22386 4.00001 7 4.22387 7 4.50001V7.50001C7 7.63262 7.05268 7.7598 7.14645 7.85357L9.14645 9.85357C9.34171 10.0488 9.65829 10.0488 9.85355 9.85357C10.0488 9.65831 10.0488 9.34172 9.85355 9.14646L8 7.29291V4.50001Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    ></path>
  </svg>
)

export const ArrowDiagonalTopRightIcon: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.64645 11.3536C3.45118 11.1583 3.45118 10.8417 3.64645 10.6465L10.2929 4L6 4C5.72386 4 5.5 3.77614 5.5 3.5C5.5 3.22386 5.72386 3 6 3L11.5 3C11.6326 3 11.7598 3.05268 11.8536 3.14645C11.9473 3.24022 12 3.36739 12 3.5L12 9.00001C12 9.27615 11.7761 9.50001 11.5 9.50001C11.2239 9.50001 11 9.27615 11 9.00001V4.70711L4.35355 11.3536C4.15829 11.5488 3.84171 11.5488 3.64645 11.3536Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    ></path>
  </svg>
)

export const DiscordLogo: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.07451 1.82584C5.03267 1.81926 4.99014 1.81825 4.94803 1.82284C4.10683 1.91446 2.82673 2.36828 2.07115 2.77808C2.02106 2.80525 1.97621 2.84112 1.93869 2.88402C1.62502 3.24266 1.34046 3.82836 1.11706 4.38186C0.887447 4.95076 0.697293 5.55032 0.588937 5.98354C0.236232 7.39369 0.042502 9.08728 0.0174948 10.6925C0.0162429 10.7729 0.0351883 10.8523 0.0725931 10.9234C0.373679 11.496 1.02015 12.027 1.66809 12.4152C2.32332 12.8078 3.08732 13.1182 3.70385 13.1778C3.85335 13.1922 4.00098 13.1358 4.10282 13.0255C4.2572 12.8581 4.5193 12.4676 4.71745 12.1643C4.80739 12.0267 4.89157 11.8953 4.95845 11.7901C5.62023 11.9106 6.45043 11.9801 7.50002 11.9801C8.54844 11.9801 9.37796 11.9107 10.0394 11.7905C10.1062 11.8957 10.1903 12.0269 10.2801 12.1643C10.4783 12.4676 10.7404 12.8581 10.8947 13.0255C10.9966 13.1358 11.1442 13.1922 11.2937 13.1778C11.9102 13.1182 12.6742 12.8078 13.3295 12.4152C13.9774 12.027 14.6239 11.496 14.925 10.9234C14.9624 10.8523 14.9813 10.7729 14.9801 10.6925C14.9551 9.08728 14.7613 7.39369 14.4086 5.98354C14.3003 5.55032 14.1101 4.95076 13.8805 4.38186C13.6571 3.82836 13.3725 3.24266 13.0589 2.88402C13.0214 2.84112 12.9765 2.80525 12.9264 2.77808C12.1708 2.36828 10.8907 1.91446 10.0495 1.82284C10.0074 1.81825 9.96489 1.81926 9.92305 1.82584C9.71676 1.85825 9.5391 1.96458 9.40809 2.06355C9.26977 2.16804 9.1413 2.29668 9.0304 2.42682C8.86968 2.61544 8.71437 2.84488 8.61428 3.06225C8.27237 3.03501 7.90138 3.02 7.5 3.02C7.0977 3.02 6.72593 3.03508 6.38337 3.06244C6.28328 2.84501 6.12792 2.61549 5.96716 2.42682C5.85626 2.29668 5.72778 2.16804 5.58947 2.06355C5.45846 1.96458 5.2808 1.85825 5.07451 1.82584ZM11.0181 11.5382C11.0395 11.5713 11.0615 11.6051 11.0838 11.6392C11.2169 11.843 11.3487 12.0385 11.4508 12.1809C11.8475 12.0916 12.352 11.8818 12.8361 11.5917C13.3795 11.2661 13.8098 10.8918 14.0177 10.5739C13.9852 9.06758 13.7993 7.50369 13.4773 6.21648C13.38 5.82759 13.2038 5.27021 12.9903 4.74117C12.7893 4.24326 12.5753 3.82162 12.388 3.5792C11.7376 3.24219 10.7129 2.88582 10.0454 2.78987C10.0308 2.79839 10.0113 2.81102 9.98675 2.82955C9.91863 2.881 9.84018 2.95666 9.76111 3.04945C9.71959 3.09817 9.68166 3.1471 9.64768 3.19449C9.953 3.25031 10.2253 3.3171 10.4662 3.39123C11.1499 3.6016 11.6428 3.89039 11.884 4.212C12.0431 4.42408 12.0001 4.72494 11.788 4.884C11.5759 5.04306 11.2751 5.00008 11.116 4.788C11.0572 4.70961 10.8001 4.4984 10.1838 4.30877C9.58933 4.12585 8.71356 3.98 7.5 3.98C6.28644 3.98 5.41067 4.12585 4.81616 4.30877C4.19988 4.4984 3.94279 4.70961 3.884 4.788C3.72494 5.00008 3.42408 5.04306 3.212 4.884C2.99992 4.72494 2.95694 4.42408 3.116 4.212C3.35721 3.89039 3.85011 3.6016 4.53383 3.39123C4.77418 3.31727 5.04571 3.25062 5.35016 3.19488C5.31611 3.14738 5.27808 3.09831 5.23645 3.04945C5.15738 2.95666 5.07893 2.881 5.01081 2.82955C4.98628 2.81102 4.96674 2.79839 4.95217 2.78987C4.28464 2.88582 3.25999 3.24219 2.60954 3.5792C2.42226 3.82162 2.20825 4.24326 2.00729 4.74117C1.79376 5.27021 1.61752 5.82759 1.52025 6.21648C1.19829 7.50369 1.01236 9.06758 0.97986 10.5739C1.18772 10.8918 1.61807 11.2661 2.16148 11.5917C2.64557 11.8818 3.15003 12.0916 3.5468 12.1809C3.64885 12.0385 3.78065 11.843 3.9138 11.6392C3.93626 11.6048 3.95838 11.5708 3.97996 11.5375C3.19521 11.2591 2.77361 10.8758 2.50064 10.4664C2.35359 10.2458 2.4132 9.94778 2.63377 9.80074C2.85435 9.65369 3.15236 9.71329 3.29941 9.93387C3.56077 10.3259 4.24355 11.0201 7.50002 11.0201C10.7565 11.0201 11.4392 10.326 11.7006 9.93386C11.8477 9.71329 12.1457 9.65369 12.3663 9.80074C12.5869 9.94779 12.6465 10.2458 12.4994 10.4664C12.2262 10.8762 11.8041 11.2598 11.0181 11.5382ZM4.08049 7.01221C4.32412 6.74984 4.65476 6.60162 5.00007 6.59998C5.34538 6.60162 5.67603 6.74984 5.91966 7.01221C6.16329 7.27459 6.30007 7.62974 6.30007 7.99998C6.30007 8.37021 6.16329 8.72536 5.91966 8.98774C5.67603 9.25011 5.34538 9.39833 5.00007 9.39998C4.65476 9.39833 4.32412 9.25011 4.08049 8.98774C3.83685 8.72536 3.70007 8.37021 3.70007 7.99998C3.70007 7.62974 3.83685 7.27459 4.08049 7.01221ZM9.99885 6.59998C9.65354 6.60162 9.3229 6.74984 9.07926 7.01221C8.83563 7.27459 8.69885 7.62974 8.69885 7.99998C8.69885 8.37021 8.83563 8.72536 9.07926 8.98774C9.3229 9.25011 9.65354 9.39833 9.99885 9.39998C10.3442 9.39833 10.6748 9.25011 10.9184 8.98774C11.1621 8.72536 11.2989 8.37021 11.2989 7.99998C11.2989 7.62974 11.1621 7.27459 10.9184 7.01221C10.6748 6.74984 10.3442 6.60162 9.99885 6.59998Z"
      fill="currentColor"
    ></path>
  </svg>
)

export const TwitterLogo: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.71553 5.00933C7.71553 3.16672 9.20886 1.6731 11.0506 1.6731C12.1318 1.6731 12.9952 2.18453 13.5737 2.92673C14.195 2.7996 14.7794 2.56969 15.308 2.25604C15.0996 2.90767 14.6585 3.45553 14.0835 3.80223L14.085 3.8056C14.6489 3.73714 15.1854 3.58718 15.6851 3.36578L15.6839 3.36758C15.3244 3.90591 14.8726 4.38114 14.3531 4.76832C14.3811 4.95646 14.3953 5.14584 14.3953 5.33413C14.3953 9.26619 11.3997 13.8395 5.88925 13.8395C4.20162 13.8395 2.62975 13.345 1.30667 12.4962C1.05876 12.3371 0.986733 12.0072 1.1458 11.7593C1.15984 11.7373 1.17524 11.7169 1.19178 11.6977C1.28616 11.5415 1.46596 11.4462 1.65904 11.469C2.63532 11.5841 3.61134 11.465 4.47162 11.0892C3.61836 10.7129 2.95599 9.98369 2.66879 9.08768C2.61711 8.92646 2.65419 8.74994 2.76636 8.62312C2.77025 8.61873 2.77421 8.61442 2.77823 8.61019C2.09479 8.00869 1.66366 7.12751 1.66366 6.14548V6.10938C1.66366 5.9393 1.75367 5.78192 1.90027 5.69568C1.94844 5.66734 2.00035 5.64807 2.05363 5.63791C1.81914 5.1856 1.68652 4.67178 1.68652 4.12751C1.68652 3.62838 1.68938 2.99934 2.04083 2.43282C2.11961 2.30582 2.24804 2.22838 2.38544 2.21003C2.58756 2.14648 2.81688 2.20762 2.95895 2.38184C4.123 3.8093 5.80332 4.79551 7.71586 5.05554L7.71553 5.00933Z"
      fill="currentColor"
    />
  </svg>
)

export const VerifiedIcon: FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    enable-background="new 0 0 24 24"
    height="16"
    viewBox="0 0 24 24"
    width="16"
    {...props}
  >
    <path
      d="M23,12l-2.44-2.79l0.34-3.69l-3.61-0.82L15.4,1.5L12,2.96L8.6,1.5L6.71,4.69L3.1,5.5L3.44,9.2L1,12l2.44,2.79l-0.34,3.7 l3.61,0.82L8.6,22.5l3.4-1.47l3.4,1.46l1.89-3.19l3.61-0.82l-0.34-3.69L23,12z M10.09,16.72l-3.8-3.81l1.48-1.48l2.32,2.33 l5.85-5.87l1.48,1.48L10.09,16.72z"
      fill="currentColor"
    />
  </svg>
)

export const InstagramLogo: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.9091 12.909C13.2365 12.5817 13.4918 12.1895 13.6588 11.7577C13.8195 11.3443 13.9294 10.8718 13.961 10.1799C13.9926 9.48665 14.0001 9.26529 14.0001 7.50001C14.0001 5.73473 13.9926 5.51328 13.961 4.82008C13.9294 4.12821 13.8195 3.65573 13.6588 3.24228C13.4956 2.80857 13.2398 2.41567 12.9091 2.091C12.5844 1.76028 12.1915 1.50437 11.7578 1.34113C11.3443 1.18056 10.8718 1.0707 10.1799 1.03924C9.48675 1.00748 9.26537 1 7.50006 1C5.73476 1 5.51333 1.00748 4.82014 1.03912C4.12826 1.0707 3.65578 1.18056 3.24233 1.34125C2.80862 1.50447 2.41573 1.76032 2.09105 2.09098C1.76032 2.41563 1.5044 2.80852 1.34113 3.24225C1.18056 3.65573 1.0707 4.12821 1.03924 4.82008C1.00748 5.51328 1 5.73471 1 7.50001C1 9.26532 1.00748 9.48675 1.03924 10.1799C1.07083 10.8718 1.18069 11.3443 1.34138 11.7577C1.5046 12.1915 1.76045 12.5843 2.09111 12.909C2.41578 13.2397 2.80867 13.4955 3.24238 13.6587C3.65586 13.8194 4.12834 13.9293 4.82019 13.9609C5.51348 13.9925 5.73483 14 7.50012 14C9.2654 14 9.48685 13.9925 10.18 13.9609C10.8719 13.9293 11.3444 13.8194 11.7578 13.6587C12.1896 13.4917 12.5818 13.2364 12.9091 12.909ZM1.99949 6.73496C1.99974 6.94524 2.00005 7.19543 2.00005 7.50002C2.00005 7.80461 1.99974 8.0548 1.99949 8.26507C1.99849 9.08596 1.99824 9.29856 2.01963 9.7655C2.04625 10.3509 2.07823 10.7811 2.17588 11.1053C2.26976 11.417 2.37505 11.7342 2.7188 12.1171C3.06255 12.4999 3.39411 12.6733 3.81645 12.8007C4.23879 12.928 4.7696 12.9554 5.23052 12.9764C5.75332 13.0003 5.96052 13.0002 7.05714 12.9999L7.50006 12.9999C7.79304 12.9999 8.03569 13.0001 8.2409 13.0004C9.08195 13.0013 9.29425 13.0015 9.76575 12.9799C10.3512 12.9533 10.7814 12.9213 11.1056 12.8237C11.4173 12.7298 11.7345 12.6245 12.1173 12.2807C12.5001 11.937 12.6735 11.6054 12.8009 11.1831C12.9283 10.7607 12.9557 10.2299 12.9767 9.76902C13.0005 9.24689 13.0004 9.04027 13.0002 7.94749V7.94738L13.0001 7.50039L13.0001 7.05747C13.0004 5.96085 13.0005 5.75365 12.9766 5.23085C12.9556 4.76993 12.9282 4.23912 12.8009 3.81678C12.6735 3.39445 12.5001 3.06288 12.1173 2.71913C11.7345 2.37538 11.4172 2.27009 11.1056 2.17621C10.7813 2.07856 10.3511 2.04658 9.76571 2.01996C9.29421 1.99836 9.08194 1.99859 8.24092 1.99951H8.24092C8.0357 1.99974 7.79305 2.00001 7.50006 2.00001L7.05704 1.99993C5.96051 1.99964 5.75331 1.99958 5.23052 2.02343C4.7696 2.04446 4.23879 2.07183 3.81645 2.19921C3.39411 2.32659 3.06255 2.49999 2.7188 2.88281C2.37505 3.26562 2.26976 3.58286 2.17588 3.89453C2.07823 4.21874 2.04625 4.64894 2.01963 5.23437C1.99824 5.70131 1.99849 5.91401 1.99949 6.73496ZM7.49996 5.25015C6.25741 5.25015 5.25012 6.25744 5.25012 7.49999C5.25012 8.74254 6.25741 9.74983 7.49996 9.74983C8.74251 9.74983 9.7498 8.74254 9.7498 7.49999C9.7498 6.25744 8.74251 5.25015 7.49996 5.25015ZM4.25012 7.49999C4.25012 5.70515 5.70512 4.25015 7.49996 4.25015C9.2948 4.25015 10.7498 5.70515 10.7498 7.49999C10.7498 9.29483 9.2948 10.7498 7.49996 10.7498C5.70512 10.7498 4.25012 9.29483 4.25012 7.49999ZM10.9697 4.7803C11.3839 4.7803 11.7197 4.44452 11.7197 4.0303C11.7197 3.61609 11.3839 3.2803 10.9697 3.2803C10.5555 3.2803 10.2197 3.61609 10.2197 4.0303C10.2197 4.44452 10.5555 4.7803 10.9697 4.7803Z"
      fill="currentColor"
    ></path>
  </svg>
)

export const OpenseaLogo: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.80024 7.87861L1.84879 7.80234L4.77537 3.22409C4.81812 3.15704 4.91869 3.16399 4.95104 3.23679C5.43997 4.33254 5.86184 5.69526 5.66419 6.54364C5.57982 6.89269 5.34867 7.36544 5.08859 7.80234C5.05507 7.86591 5.01809 7.92834 4.97879 7.98844C4.96029 8.01616 4.92909 8.03236 4.89557 8.03236H1.88577C1.80487 8.03236 1.75749 7.94451 1.80024 7.87861Z"
      fill="currentColor"
    />
    <path
      d="M14.8446 8.72873V9.45343C14.8446 9.49503 14.8192 9.53202 14.7822 9.5482C14.5557 9.6453 13.7801 10.0013 13.4576 10.4497C12.6347 11.5952 12.0059 13.233 10.6004 13.233H4.73686C2.65866 13.233 0.974609 11.5432 0.974609 9.45805V9.391C0.974609 9.33552 1.01968 9.29045 1.07518 9.29045H4.34386C4.40858 9.29045 4.45598 9.35055 4.45021 9.41413C4.42708 9.6268 4.46638 9.8441 4.56693 10.0417C4.76113 10.4359 5.16336 10.6821 5.59796 10.6821H7.21611V9.41875H5.61643C5.53438 9.41875 5.48583 9.32397 5.53323 9.25692C5.55056 9.23035 5.57021 9.2026 5.59101 9.1714C5.74243 8.95643 5.95856 8.62237 6.17356 8.2421C6.32033 7.98552 6.46251 7.71157 6.57693 7.4365C6.60006 7.3868 6.61856 7.33595 6.63703 7.28623C6.66826 7.1984 6.70061 7.11633 6.72373 7.03428C6.74683 6.96493 6.76533 6.8921 6.78383 6.8239C6.83816 6.59043 6.86128 6.34308 6.86128 6.08648C6.86128 5.98593 6.85666 5.88075 6.84741 5.78018C6.84278 5.67038 6.82891 5.56058 6.81503 5.45078C6.80578 5.35368 6.78846 5.25775 6.76996 5.1572C6.74683 5.0104 6.71448 4.86477 6.67748 4.71797L6.66478 4.6625C6.63703 4.56195 6.61393 4.466 6.58156 4.36545C6.49026 4.0499 6.38506 3.74245 6.27411 3.45465C6.23366 3.34022 6.18741 3.23043 6.14118 3.12063C6.07298 2.95533 6.00363 2.80507 5.94008 2.6629C5.90771 2.59817 5.87996 2.53923 5.85223 2.47913C5.82103 2.41093 5.78866 2.34275 5.75631 2.278C5.73318 2.2283 5.70658 2.18207 5.68811 2.13585L5.49046 1.7706C5.46271 1.7209 5.50896 1.66195 5.56326 1.67697L6.80001 2.01218H6.80348C6.80578 2.01218 6.80696 2.01333 6.80811 2.01333L6.97108 2.0584L7.15023 2.10925L7.21611 2.12775V1.39265C7.21611 1.0378 7.50046 0.75 7.85183 0.75C8.02751 0.75 8.18701 0.82165 8.30143 0.9384C8.41586 1.05515 8.48753 1.21465 8.48753 1.39265V2.48375L8.61928 2.52072C8.62971 2.5242 8.64011 2.52882 8.64936 2.53575C8.68171 2.56002 8.72793 2.59587 8.78688 2.63977C8.83313 2.67677 8.88283 2.72185 8.94293 2.76807C9.06198 2.86402 9.20413 2.9877 9.36018 3.12985C9.40178 3.1657 9.44226 3.20268 9.47923 3.23968C9.68036 3.4269 9.90574 3.64652 10.1207 3.88925C10.1808 3.95742 10.2398 4.02677 10.2999 4.0996C10.36 4.17357 10.4236 4.2464 10.479 4.31923C10.5519 4.4163 10.6304 4.51685 10.6986 4.62205C10.731 4.67175 10.768 4.7226 10.7992 4.7723C10.887 4.90522 10.9645 5.04277 11.0385 5.1803C11.0697 5.24387 11.102 5.31322 11.1298 5.38142C11.2118 5.5652 11.2766 5.75245 11.3182 5.9397C11.3309 5.98015 11.3401 6.02408 11.3448 6.06338V6.0726C11.3586 6.1281 11.3632 6.18705 11.3679 6.24715C11.3864 6.439 11.3771 6.63088 11.3355 6.8239C11.3182 6.90598 11.2951 6.9834 11.2673 7.06548C11.2396 7.14408 11.2118 7.22612 11.176 7.30357C11.1067 7.46422 11.0246 7.6249 10.9275 7.77515C10.8963 7.83063 10.8593 7.88958 10.8223 7.94505C10.7819 8.004 10.7403 8.0595 10.7033 8.11382C10.6524 8.18317 10.5981 8.25597 10.5426 8.3207C10.4929 8.3889 10.442 8.4571 10.3866 8.5172C10.3091 8.6085 10.2352 8.6952 10.1577 8.77843C10.1115 8.83275 10.0618 8.88823 10.0109 8.93793C9.96121 8.9934 9.91036 9.0431 9.86413 9.08932C9.78668 9.16677 9.72196 9.22688 9.66763 9.27658L9.54049 9.39332C9.52201 9.4095 9.49773 9.41875 9.47231 9.41875H8.48753V10.6821H9.72659C10.004 10.6821 10.2675 10.5838 10.4802 10.4035C10.553 10.34 10.8709 10.0649 11.2465 9.64993C11.2592 9.63605 11.2754 9.62565 11.2939 9.62103L14.7163 8.63163C14.7799 8.61313 14.8446 8.66168 14.8446 8.72873Z"
      fill="currentColor"
    />
  </svg>
)

export const DiscordFilledLogo: FC<IconProps> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.9308 3.8818C15.6561 3.31907 14.2892 2.90447 12.8599 2.66701C12.8339 2.66243 12.8079 2.67388 12.7945 2.69679C12.6187 2.99762 12.4239 3.39007 12.2876 3.69854C10.7503 3.47712 9.22099 3.47712 7.71527 3.69854C7.57887 3.38322 7.37707 2.99762 7.20048 2.69679C7.18707 2.67465 7.16107 2.66319 7.13504 2.66701C5.70659 2.90371 4.33963 3.31831 3.06411 3.8818C3.05307 3.88638 3.04361 3.89402 3.03732 3.90394C0.444493 7.63077 -0.265792 11.266 0.0826501 14.8562C0.0842267 14.8737 0.0944749 14.8905 0.108665 14.9012C1.81934 16.1099 3.47642 16.8436 5.10273 17.33C5.12876 17.3377 5.15634 17.3285 5.1729 17.3079C5.55761 16.8024 5.90054 16.2695 6.19456 15.709C6.21192 15.6762 6.19535 15.6373 6.15989 15.6243C5.61594 15.4258 5.098 15.1837 4.59978 14.9088C4.56037 14.8867 4.55721 14.8325 4.59347 14.8065C4.69831 14.7309 4.80318 14.6523 4.9033 14.5729C4.92141 14.5584 4.94665 14.5553 4.96794 14.5645C8.24107 16.0022 11.7846 16.0022 15.0191 14.5645C15.0404 14.5545 15.0657 14.5576 15.0846 14.5721C15.1847 14.6515 15.2896 14.7309 15.3952 14.8065C15.4314 14.8325 15.4291 14.8867 15.3897 14.9088C14.8914 15.189 14.3735 15.4258 13.8288 15.6235C13.7933 15.6365 13.7775 15.6762 13.7949 15.709C14.0952 16.2687 14.4381 16.8016 14.8157 17.3071C14.8315 17.3285 14.8599 17.3377 14.8859 17.33C16.5201 16.8436 18.1772 16.1099 19.8879 14.9012C19.9028 14.8905 19.9123 14.8745 19.9139 14.8569C20.3309 10.7063 19.2154 7.10089 16.9568 3.9047C16.9513 3.89402 16.9419 3.88638 16.9308 3.8818ZM6.68335 12.6701C5.69792 12.6701 4.88594 11.7997 4.88594 10.7307C4.88594 9.66179 5.68217 8.79137 6.68335 8.79137C7.69239 8.79137 8.49651 9.66943 8.48073 10.7307C8.48073 11.7997 7.68451 12.6701 6.68335 12.6701ZM13.329 12.6701C12.3435 12.6701 11.5316 11.7997 11.5316 10.7307C11.5316 9.66179 12.3278 8.79137 13.329 8.79137C14.338 8.79137 15.1421 9.66943 15.1264 10.7307C15.1264 11.7997 14.338 12.6701 13.329 12.6701Z"
      fill="currentColor"
    />
  </svg>
)

export const QuestionMarkCicleIcon: FC<IconProps> = (props) => (
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.25 16.5C12.3921 16.5 15.75 13.1421 15.75 9C15.75 4.85786 12.3921 1.5 8.25 1.5C4.10786 1.5 0.75 4.85786 0.75 9C0.75 13.1421 4.10786 16.5 8.25 16.5Z"
      stroke="#3E3E3E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.0675 6.74994C6.24383 6.24869 6.59187 5.82602 7.04997 5.55679C7.50807 5.28756 8.04668 5.18914 8.57039 5.27897C9.0941 5.3688 9.56912 5.64108 9.91131 6.04758C10.2535 6.45409 10.4408 6.96858 10.44 7.49994C10.44 8.99994 8.19 9.74994 8.19 9.74994"
      stroke="#3E3E3E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.25 12.75H8.2578"
      stroke="#3E3E3E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const QuestionMarkIcon: FC<IconProps> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5006 13.9568L7.41132 10.0975H8.25947C9.06297 10.0975 9.79952 10.0186 10.4691 9.86072C11.1536 9.70288 11.6967 9.39508 12.0984 8.93733C12.5151 8.47957 12.7234 7.80084 12.7234 6.90111C12.7234 6.03296 12.4704 5.35422 11.9645 4.8649C11.4586 4.3598 10.7965 4.10724 9.97808 4.10724C9.12993 4.10724 8.46034 4.3519 7.96931 4.84123C7.47828 5.33055 7.23276 5.9935 7.23276 6.83008H5.0008C4.98592 5.88301 5.17935 5.04643 5.58111 4.32033C5.99774 3.59424 6.57805 3.026 7.32204 2.6156C8.08091 2.2052 8.96626 2 9.97808 2C10.9601 2 11.8306 2.19731 12.5895 2.59192C13.3483 2.98654 13.9361 3.55478 14.3527 4.29666C14.7842 5.02275 15 5.89879 15 6.92479C15 8.0455 14.7694 8.96889 14.3081 9.69499C13.8468 10.4053 13.2144 10.9341 12.4109 11.2813C11.6074 11.6128 10.6849 11.7786 9.64328 11.7786L9.57633 13.9568H7.5006ZM8.54962 19C8.08835 19 7.71635 18.85 7.43364 18.5501C7.15092 18.2344 7.00957 17.8635 7.00957 17.4373C7.00957 16.9954 7.15092 16.6244 7.43364 16.3245C7.71635 16.0088 8.08835 15.851 8.54962 15.851C8.98113 15.851 9.33825 16.0088 9.62096 16.3245C9.91856 16.6244 10.0674 16.9954 10.0674 17.4373C10.0674 17.8635 9.91856 18.2344 9.62096 18.5501C9.33825 18.85 8.98113 19 8.54962 19Z"
      fill="currentColor"
    />
  </svg>
)

export const LogoutIcon: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 15H3C2.60218 15 2.22064 14.842 1.93934 14.5607C1.65804 14.2794 1.5 13.8978 1.5 13.5V3C1.5 2.60218 1.65804 2.22064 1.93934 1.93934C2.22064 1.65804 2.60218 1.5 3 1.5H6"
      stroke="#3E3E3E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.25 12L15 8.25L11.25 4.5"
      stroke="#3E3E3E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 8.25H6"
      stroke="#3E3E3E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const UserIcon: FC<IconProps> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.41671 5.00002C7.41671 3.57328 8.57331 2.41669 10 2.41669C11.4268 2.41669 12.5834 3.57328 12.5834 5.00002C12.5834 6.42676 11.4268 7.58335 10 7.58335C8.57331 7.58335 7.41671 6.42676 7.41671 5.00002ZM10 0.916687C7.74488 0.916687 5.91671 2.74486 5.91671 5.00002C5.91671 7.25518 7.74488 9.08335 10 9.08335C12.2552 9.08335 14.0834 7.25518 14.0834 5.00002C14.0834 2.74486 12.2552 0.916687 10 0.916687ZM7.33337 10.9167C4.71002 10.9167 2.58337 13.0433 2.58337 15.6667C2.58337 17.5537 4.11307 19.0834 6.00004 19.0834H14C15.887 19.0834 17.4167 17.5537 17.4167 15.6667C17.4167 13.0433 15.2901 10.9167 12.6667 10.9167H7.33337ZM4.08337 15.6667C4.08337 13.8718 5.53845 12.4167 7.33337 12.4167H12.6667C14.4616 12.4167 15.9167 13.8718 15.9167 15.6667C15.9167 16.7252 15.0586 17.5834 14 17.5834H6.00004C4.94149 17.5834 4.08337 16.7252 4.08337 15.6667Z"
      fill="currentColor"
    />
  </svg>
)

export const AvatarFallbackIcon: FC<IconProps> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="7.5" cy="5.5" r="2.5" fill="currentColor" />
    <path
      d="M7.5 9C4.18629 9 1.5 11.6863 1.5 15H13.5C13.5 11.6863 10.8137 9 7.5 9Z"
      fill="currentColor"
    />
  </svg>
)
export const ArpeggiLightLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <g clipPath="url(#clip0_353_6678)">
      <g filter="url(#filter0_i_353_6678)">
        <path
          d="M7.05784 0H-0.000793457V30H8.82274V17.6471H7.05784V0Z"
          fill={props.fill || '#E8E8E8'}
        />
      </g>
      <g filter="url(#filter1_i_353_6678)">
        <path
          d="M10.5878 30V17.6471H12.3538V0H17.647V17.6471H19.4113V30H10.5878Z"
          fill={props.fill || '#E8E8E8'}
        />
      </g>
      <g filter="url(#filter2_i_353_6678)">
        <path
          d="M21.1778 17.6471V30H30.0013V0H22.9439V17.6471H21.1778Z"
          fill={props.fill || '#E8E8E8'}
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_i_353_6678"
        x="-0.000793457"
        y="0"
        width="8.82355"
        height="33.5931"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.59314" />
        <feGaussianBlur stdDeviation="2.69485" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_353_6678" />
      </filter>
      <filter
        id="filter1_i_353_6678"
        x="10.5878"
        y="0"
        width="8.82355"
        height="33.5931"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.59314" />
        <feGaussianBlur stdDeviation="2.69485" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_353_6678" />
      </filter>
      <filter
        id="filter2_i_353_6678"
        x="21.1778"
        y="0"
        width="8.82355"
        height="33.5931"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.59314" />
        <feGaussianBlur stdDeviation="2.69485" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_353_6678" />
      </filter>
      <clipPath id="clip0_353_6678">
        <rect width="30" height="30" rx="2.39152" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const InfoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,
  0 22,12A10,10 0 0,0 12,2Z"
    />
  </svg>
)

export const ErrorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      d="M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,
        6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,
        13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
    />
  </svg>
)

export const SampleWavIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="7"
    height="38"
    viewBox="0 0 7 38"
    fill="none"
    {...props}
  >
    <g opacity="0.5">
      <path
        d="M0.999878 14.0195V23.7855"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M1.74744 14.0195V23.7855"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M1.05322 5.21387L1.05322 32.7883"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M1.80078 5.21387L1.80078 32.7883"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M1.10669 1L1.10669 37"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M1.85413 1L1.85413 37"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M1.16003 9.04102L1.16003 28.9559"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M1.90759 9.04102L1.90759 28.9559"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M1.21338 15.9365L1.21338 22.0642"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M1.96094 10.334L1.96094 29.0007"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M1.26685 2.91406L1.26685 35.0843"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M2.0144 2.91406L2.0144 35.0843"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M1.32019 7.51172L1.32019 30.4904"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M2.06775 5L2.06775 31.6667"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M1.37354 10.959L1.37354 27.0441"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M2.12109 9.00098L2.12109 30.3343"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M1.427 15.9365L1.427 22.0642"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M2.17456 11.667L2.17456 27.667"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M1.48035 17.8525L1.48035 20.1504"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M2.22791 11.667L2.22791 27.667"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M1.53381 17.8525L1.53381 20.1504"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M2.28137 14.334L2.28137 25.0007"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M1.58716 16.3203L1.58716 21.682"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M2.33472 16.3203L2.33472 21.682"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M1.64062 10.5752L1.64063 27.4263"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M1.69397 14.0195V23.7855"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M2.51501 16.999V20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M3.4021 16.999V20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M4.28918 16.999V20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M5.17627 16.999V20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M2.57837 16.999L2.57837 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M3.46545 16.999L3.46545 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M4.35254 16.999L4.35254 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M5.23962 16.999L5.23962 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M2.64172 16.999L2.64172 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M3.52881 16.999L3.52881 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M4.41589 16.999L4.41589 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M5.30298 16.999L5.30298 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M2.70508 16.999L2.70508 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M3.59216 16.999L3.59216 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M4.47925 16.999L4.47925 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M5.36633 16.999L5.36633 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M2.76843 16.999L2.76843 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M3.65552 16.999L3.65552 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M4.5426 16.999L4.5426 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M5.42969 16.999L5.42969 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M2.83179 16.999L2.83179 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M3.71887 16.999L3.71887 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M4.60608 16.999L4.60608 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M5.49304 16.999L5.49304 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M2.89514 16.999L2.89514 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M3.78223 16.999L3.78223 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M4.66931 16.999L4.66931 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M5.5564 16.999L5.5564 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M2.9585 16.999L2.9585 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M3.8457 16.999L3.8457 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M4.73279 16.999L4.73279 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M5.61975 16.999L5.61975 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M3.02185 16.999L3.02185 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M3.90906 16.999L3.90906 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M4.79602 16.999L4.79602 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M5.68323 16.999L5.68323 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M3.08533 16.999L3.08533 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M3.97229 16.999L3.97229 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M4.8595 16.999L4.8595 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M5.74646 16.999L5.74646 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M3.14868 16.999L3.14868 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M4.03564 16.999L4.03564 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M4.92285 16.999L4.92285 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M5.80994 16.999L5.80994 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M3.21204 16.999L3.21204 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M4.09912 16.999L4.09912 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M4.98621 16.999L4.98621 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M5.87317 16.999L5.87317 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M2.38818 16.999L2.38873 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M3.27539 16.999L3.27539 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M4.16248 16.999L4.16248 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M5.04956 16.999L5.04956 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M5.93665 16.999L5.93665 20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M2.45154 16.999V20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M3.33875 16.999V20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M4.22583 16.999V20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M5.11292 16.999V20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
      <path
        d="M6 16.999V20.999"
        stroke="currentColor"
        strokeWidth="0.851471"
        strokeLinecap="round"
      />
    </g>
  </svg>
)

export const SuccessIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41
        10.59L10 14.17L17.59 6.58L19 8L10 17Z"
    ></path>
  </svg>
)

export const Check = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    ></path>
  </svg>
)

export const TwitterDark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 14.1978C2.24772 14.4155 4.25801 13.8713 6.0467 12.5263C4.91492 12.4719 3.94935 12.0598 3.16581 11.259C2.73051 10.8159 2.42184 10.3028 2.22398 9.7119C2.778 9.81297 3.3241 9.80519 3.86229 9.68858C3.9256 9.67303 3.98892 9.65748 4.06807 9.64193C1.99446 9.20655 0.743965 7.41064 0.783538 5.63027C1.3613 5.93347 1.97072 6.10451 2.63554 6.13561C1.74911 5.52142 1.16343 4.71287 0.918085 3.67886C0.680649 2.64484 0.838939 1.67303 1.3613 0.747855C3.59319 3.32123 6.41076 4.73619 9.85358 4.96943C9.83775 4.86836 9.81401 4.77507 9.80609 4.68955C9.60823 3.30568 10.004 2.1084 11.0249 1.12103C11.6423 0.530168 12.3862 0.172539 13.241 0.0481466C14.1353 -0.0840206 14.9901 0.0559211 15.7974 0.467972C16.1852 0.67011 16.5255 0.92667 16.8263 1.22988C16.8579 1.26097 16.8817 1.26875 16.9213 1.26097C17.7918 1.08216 18.615 0.778953 19.3827 0.343579C19.4064 0.32803 19.4381 0.312481 19.4776 0.296932C19.1531 1.24543 18.5833 1.98401 17.7206 2.5049C17.8077 2.52822 18.3617 2.4427 18.8841 2.29499C19.264 2.18614 19.6359 2.0462 20.0079 1.92958C19.9446 2.02288 19.8734 2.12395 19.8021 2.21724C19.2956 2.87808 18.7099 3.46117 18.0293 3.95097C17.9897 3.98206 17.9818 4.00539 17.9818 4.05203C18.0055 4.72064 17.9739 5.38926 17.8789 6.05009C17.7602 6.85087 17.5623 7.6361 17.2853 8.40578C16.8342 9.63415 16.2089 10.7615 15.3858 11.7799C14.4282 12.9694 13.2806 13.9335 11.9272 14.6565C10.9537 15.1774 9.9169 15.5428 8.83261 15.7605C7.81163 15.9626 6.78275 16.0404 5.73803 15.9937C4.81203 15.9549 3.90977 15.7994 3.01543 15.5506C1.95489 15.2396 0.973486 14.8042 0.0474871 14.2289C0.0316581 14.2211 0.0237436 14.2134 0 14.1978Z"
      fill="#141414"
    />
  </svg>
)

export const InstagramDark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.2015 25.532C15.1737 25.532 14.148 25.5415 13.1202 25.5282C12.4126 25.5205 11.705 25.4995 11.0034 25.3981C9.37671 25.161 8.04061 24.4574 7.11561 23.1094C6.65905 22.444 6.40408 21.7002 6.27165 20.9182C6.12737 20.073 6.11353 19.2184 6.10958 18.3656C6.10168 16.4841 6.10563 14.6026 6.11749 12.7212C6.12144 12.0596 6.14911 11.398 6.24991 10.7403C6.48511 9.21443 7.17688 7.94674 8.50508 7.04615C9.18895 6.58343 9.9578 6.32339 10.7721 6.17617C11.5489 6.03658 12.3355 6.01173 13.1222 6.0079C15.1797 5.99643 17.2372 5.99834 19.2947 6.0079C20.0023 6.01173 20.7099 6.03658 21.4115 6.13792C23.0303 6.37311 24.3624 7.07101 25.2894 8.40946C25.7519 9.07868 26.0088 9.82821 26.1452 10.6179C26.2895 11.463 26.3033 12.3177 26.3073 13.1705C26.3152 15.052 26.3132 16.9334 26.2994 18.8168C26.2954 19.4784 26.2678 20.14 26.167 20.7977C25.9377 22.2796 25.2775 23.5243 24.0086 24.4268C23.3327 24.9067 22.5678 25.1821 21.7535 25.3427C21.1408 25.4632 20.5201 25.5014 19.8995 25.5129C18.6682 25.5358 17.4368 25.5492 16.2075 25.5664C16.2015 25.5549 16.2015 25.5435 16.2015 25.532ZM24.5186 15.7671C24.5067 14.6944 24.5008 13.6217 24.481 12.5472C24.4692 11.9755 24.4534 11.4018 24.3446 10.8359C24.2438 10.3062 24.0758 9.79953 23.7596 9.34828C23.2161 8.57198 22.4452 8.13221 21.5104 7.93526C20.8759 7.80142 20.2316 7.77083 19.5872 7.76891C17.3321 7.75744 15.0789 7.75935 12.8237 7.767C12.2485 7.76891 11.6714 7.79377 11.1022 7.89702C10.531 8.00027 9.98745 8.17236 9.50914 8.50123C8.74029 9.02896 8.30546 9.76129 8.10781 10.6427C7.97341 11.247 7.94574 11.8607 7.93586 12.4745C7.8983 14.943 7.86273 17.4095 7.97341 19.8761C7.99713 20.3866 8.07816 20.8876 8.24814 21.3752C8.54264 22.2203 9.0921 22.857 9.91234 23.2662C10.4144 23.5167 10.9579 23.6524 11.5192 23.6945C12.1497 23.7404 12.7802 23.7824 13.4127 23.7844C15.4841 23.7901 17.5534 23.7824 19.6248 23.7691C20.1901 23.7652 20.7573 23.7404 21.3167 23.641C21.8622 23.5434 22.384 23.3828 22.8465 23.0788C23.6529 22.5511 24.1094 21.8035 24.313 20.8952C24.4534 20.2662 24.4751 19.6256 24.487 18.987C24.5028 17.9124 24.5067 16.8397 24.5186 15.7671Z"
      fill="#141414"
    />
    <path
      d="M16.2009 20.7894C13.341 20.7875 11.0146 18.5351 11.0146 15.7664C11.0146 12.9959 13.3469 10.7415 16.2128 10.7454C19.0747 10.7473 21.399 12.9997 21.399 15.7684C21.399 18.5389 19.0668 20.7914 16.2009 20.7894ZM19.5866 15.776C19.5886 13.9672 18.0865 12.5045 16.2187 12.4987C14.3529 12.493 12.833 13.9519 12.8291 15.755C12.8251 17.5676 14.3312 19.0342 16.2029 19.0361C18.0667 19.0399 19.5827 17.581 19.5866 15.776Z"
      fill="#141414"
    />
    <path
      d="M21.6012 11.7291C20.9332 11.731 20.3897 11.209 20.3897 10.5608C20.3877 9.91261 20.9272 9.3887 21.5972 9.3887C22.2692 9.3887 22.8087 9.90878 22.8087 10.557C22.8087 11.2071 22.2712 11.7271 21.6012 11.7291Z"
      fill="#141414"
    />
  </svg>
)

export const DiscordDark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="16"
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.16075 13.7528C6.60892 13.5322 6.12485 13.3524 5.66983 13.1399C5.4762 13.0501 5.11799 13.0092 5.26321 12.6987C5.37939 12.4535 5.84409 12.3146 6.14421 12.4045C7.00585 12.6578 7.84813 12.952 8.72913 13.1399C11.8078 13.7855 14.809 13.4995 17.7231 12.4699C17.8973 12.4127 18.1297 12.3146 18.2555 12.3636C18.4685 12.4454 18.6234 12.6333 18.8074 12.7804C18.6718 12.8948 18.5557 13.0501 18.3911 13.1318C17.9167 13.3524 17.423 13.5403 16.8711 13.761C17.2293 14.2594 17.5875 14.7497 17.9845 15.2891C18.6718 15.0603 19.3689 14.8887 19.9982 14.619C21.218 14.0878 22.4088 13.4995 23.5996 12.9193C23.7449 12.8458 23.8901 12.6578 23.8998 12.5107C24.3548 8.46578 23.0962 4.79673 20.4726 1.43003C20.3854 1.31563 20.2305 1.21757 20.0756 1.16037C18.6331 0.621042 17.1422 0.228805 15.5351 0C15.3899 0.236977 15.2253 0.465781 15.1188 0.719101C14.9929 1.02145 14.7703 1.06231 14.4217 1.05414C13.1535 1.00511 11.8949 0.980593 10.6267 0.964249C10.2394 0.956078 9.86184 1.01328 9.47459 1.05414C9.18415 1.08682 9.02925 1.00511 8.92275 0.776302C8.7969 0.514811 8.63231 0.269663 8.47741 0.0081716C6.84127 0.236977 5.31162 0.645557 3.83038 1.20123C3.68516 1.25843 3.56898 1.38917 3.47217 1.51175C1.09056 4.54341 -0.090559 7.86926 0.0062542 11.5138C0.0159359 11.8652 0.0449791 12.2165 0.103067 12.5679C0.122431 12.6742 0.209562 12.7886 0.306376 12.8539C1.57463 13.7201 4.46935 14.9132 6.05708 15.2319C6.41529 14.7497 6.78318 14.2594 7.16075 13.7528ZM13.6763 8.69459C13.6569 7.7712 13.899 7.21553 14.4411 6.75792C15.4189 5.92441 16.9292 5.99796 17.8199 6.91318C18.7396 7.85291 18.6138 9.34014 17.5198 10.141C16.8227 10.6558 16.0095 10.8029 15.1575 10.4678C14.141 10.0592 13.7053 9.33197 13.6763 8.69459ZM5.57302 8.39224C5.56333 7.86108 5.7376 7.37079 6.12485 6.95404C7.17043 5.82635 9.09702 5.94076 9.94897 7.19101C10.6073 8.15526 10.404 9.39735 9.44554 10.1164C8.73881 10.6476 7.9159 10.7947 7.04458 10.4515C6.02804 10.0511 5.59238 9.31563 5.57302 8.39224Z"
      fill="#141414"
    />
  </svg>
)

export const MirrorDark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="17"
    height="21"
    viewBox="0 0 17 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.927734 8.26876C0.927734 4.25426 4.18212 0.999878 8.19662 0.999878H8.65885C12.6733 0.999878 15.9277 4.25427 15.9277 8.26876V19.2142H0.927734V8.26876Z"
      stroke="black"
      strokeWidth="1.60714"
    />
  </svg>
)

export const TwitterLight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 14.1978C2.24772 14.4155 4.25801 13.8713 6.0467 12.5263C4.91492 12.4719 3.94935 12.0598 3.16581 11.259C2.73051 10.8159 2.42184 10.3028 2.22398 9.7119C2.778 9.81297 3.3241 9.80519 3.86229 9.68858C3.9256 9.67303 3.98892 9.65748 4.06807 9.64193C1.99446 9.20655 0.743965 7.41064 0.783538 5.63027C1.3613 5.93347 1.97072 6.10451 2.63554 6.13561C1.74911 5.52142 1.16343 4.71287 0.918085 3.67886C0.680649 2.64484 0.838939 1.67303 1.3613 0.747855C3.59319 3.32123 6.41076 4.73619 9.85358 4.96943C9.83775 4.86836 9.81401 4.77507 9.80609 4.68955C9.60823 3.30568 10.004 2.1084 11.0249 1.12103C11.6423 0.530168 12.3862 0.172539 13.241 0.0481466C14.1353 -0.0840206 14.9901 0.0559211 15.7974 0.467972C16.1852 0.67011 16.5255 0.92667 16.8263 1.22988C16.8579 1.26097 16.8817 1.26875 16.9213 1.26097C17.7918 1.08216 18.615 0.778953 19.3827 0.343579C19.4064 0.32803 19.4381 0.312481 19.4776 0.296932C19.1531 1.24543 18.5833 1.98401 17.7206 2.5049C17.8077 2.52822 18.3617 2.4427 18.8841 2.29499C19.264 2.18614 19.6359 2.0462 20.0079 1.92958C19.9446 2.02288 19.8734 2.12395 19.8021 2.21724C19.2956 2.87808 18.7099 3.46117 18.0293 3.95097C17.9897 3.98206 17.9818 4.00539 17.9818 4.05203C18.0055 4.72064 17.9739 5.38926 17.8789 6.05009C17.7602 6.85087 17.5623 7.6361 17.2853 8.40578C16.8342 9.63415 16.2089 10.7615 15.3858 11.7799C14.4282 12.9694 13.2806 13.9335 11.9272 14.6565C10.9537 15.1774 9.9169 15.5428 8.83261 15.7605C7.81163 15.9626 6.78275 16.0404 5.73803 15.9937C4.81203 15.9549 3.90977 15.7994 3.01543 15.5506C1.95489 15.2396 0.973486 14.8042 0.0474871 14.2289C0.0316581 14.2211 0.0237436 14.2134 0 14.1978Z"
      fill="#C2C2C2"
    />
  </svg>
)

export const InstagramLight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.2015 25.532C15.1737 25.532 14.148 25.5415 13.1202 25.5282C12.4126 25.5205 11.705 25.4995 11.0034 25.3981C9.37671 25.161 8.04061 24.4574 7.11561 23.1094C6.65905 22.444 6.40408 21.7002 6.27165 20.9182C6.12737 20.073 6.11353 19.2184 6.10958 18.3656C6.10168 16.4841 6.10563 14.6026 6.11749 12.7212C6.12144 12.0596 6.14911 11.398 6.24991 10.7403C6.48511 9.21443 7.17688 7.94674 8.50508 7.04615C9.18895 6.58343 9.9578 6.32339 10.7721 6.17617C11.5489 6.03658 12.3355 6.01173 13.1222 6.0079C15.1797 5.99643 17.2372 5.99834 19.2947 6.0079C20.0023 6.01173 20.7099 6.03658 21.4115 6.13792C23.0303 6.37311 24.3624 7.07101 25.2894 8.40946C25.7519 9.07868 26.0088 9.82821 26.1452 10.6179C26.2895 11.463 26.3033 12.3177 26.3073 13.1705C26.3152 15.052 26.3132 16.9334 26.2994 18.8168C26.2954 19.4784 26.2678 20.14 26.167 20.7977C25.9377 22.2796 25.2775 23.5243 24.0086 24.4268C23.3327 24.9067 22.5678 25.1821 21.7535 25.3427C21.1408 25.4632 20.5201 25.5014 19.8995 25.5129C18.6682 25.5358 17.4368 25.5492 16.2075 25.5664C16.2015 25.5549 16.2015 25.5435 16.2015 25.532ZM24.5186 15.7671C24.5067 14.6944 24.5008 13.6217 24.481 12.5472C24.4692 11.9755 24.4534 11.4018 24.3446 10.8359C24.2438 10.3062 24.0758 9.79953 23.7596 9.34828C23.2161 8.57198 22.4452 8.13221 21.5104 7.93526C20.8759 7.80142 20.2316 7.77083 19.5872 7.76891C17.3321 7.75744 15.0789 7.75935 12.8237 7.767C12.2485 7.76891 11.6714 7.79377 11.1022 7.89702C10.531 8.00027 9.98745 8.17236 9.50914 8.50124C8.74028 9.02896 8.30546 9.76129 8.10781 10.6427C7.97341 11.247 7.94574 11.8607 7.93586 12.4745C7.8983 14.943 7.86273 17.4095 7.97341 19.8761C7.99713 20.3866 8.07816 20.8876 8.24814 21.3752C8.54264 22.2203 9.0921 22.857 9.91234 23.2662C10.4144 23.5167 10.9579 23.6524 11.5192 23.6945C12.1497 23.7404 12.7802 23.7824 13.4127 23.7844C15.4841 23.7901 17.5534 23.7824 19.6248 23.7691C20.1901 23.7652 20.7573 23.7404 21.3167 23.641C21.8622 23.5434 22.384 23.3828 22.8465 23.0788C23.6529 22.5511 24.1094 21.8035 24.313 20.8952C24.4534 20.2662 24.4751 19.6256 24.487 18.987C24.5028 17.9124 24.5067 16.8397 24.5186 15.7671Z"
      fill="#C2C2C2"
    />
    <path
      d="M16.2009 20.7894C13.341 20.7875 11.0146 18.5351 11.0146 15.7664C11.0146 12.9959 13.3469 10.7415 16.2128 10.7454C19.0747 10.7473 21.399 12.9997 21.399 15.7684C21.399 18.5389 19.0668 20.7914 16.2009 20.7894ZM19.5866 15.776C19.5886 13.9672 18.0865 12.5045 16.2187 12.4987C14.3529 12.493 12.833 13.9519 12.8291 15.755C12.8251 17.5676 14.3312 19.0342 16.2029 19.0361C18.0667 19.0399 19.5827 17.581 19.5866 15.776Z"
      fill="#C2C2C2"
    />
    <path
      d="M21.6012 11.729C20.9332 11.7309 20.3897 11.2089 20.3897 10.5608C20.3877 9.91258 20.9272 9.38867 21.5972 9.38867C22.2692 9.38867 22.8087 9.90875 22.8087 10.5569C22.8087 11.207 22.2712 11.7271 21.6012 11.729Z"
      fill="#C2C2C2"
    />
  </svg>
)

export const DiscordLight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="16"
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.16075 13.7528C6.60892 13.5322 6.12485 13.3524 5.66983 13.1399C5.4762 13.0501 5.11799 13.0092 5.26321 12.6987C5.37939 12.4535 5.84409 12.3146 6.14421 12.4045C7.00585 12.6578 7.84813 12.952 8.72913 13.1399C11.8078 13.7855 14.809 13.4995 17.7231 12.4699C17.8973 12.4127 18.1297 12.3146 18.2555 12.3636C18.4685 12.4454 18.6234 12.6333 18.8074 12.7804C18.6718 12.8948 18.5557 13.0501 18.3911 13.1318C17.9167 13.3524 17.423 13.5403 16.8711 13.761C17.2293 14.2594 17.5875 14.7497 17.9845 15.2891C18.6718 15.0603 19.3689 14.8887 19.9982 14.619C21.218 14.0878 22.4088 13.4995 23.5996 12.9193C23.7449 12.8458 23.8901 12.6578 23.8998 12.5107C24.3548 8.46578 23.0962 4.79673 20.4726 1.43003C20.3854 1.31563 20.2305 1.21757 20.0756 1.16037C18.6331 0.621042 17.1422 0.228805 15.5351 0C15.3899 0.236977 15.2253 0.465781 15.1188 0.719101C14.9929 1.02145 14.7703 1.06231 14.4217 1.05414C13.1535 1.00511 11.8949 0.980593 10.6267 0.964249C10.2394 0.956078 9.86184 1.01328 9.47459 1.05414C9.18415 1.08682 9.02925 1.00511 8.92275 0.776302C8.7969 0.514811 8.63231 0.269663 8.47741 0.0081716C6.84127 0.236977 5.31162 0.645557 3.83038 1.20123C3.68516 1.25843 3.56898 1.38917 3.47217 1.51175C1.09056 4.54341 -0.090559 7.86926 0.0062542 11.5138C0.0159359 11.8652 0.0449791 12.2165 0.103067 12.5679C0.122431 12.6742 0.209562 12.7886 0.306376 12.8539C1.57463 13.7201 4.46935 14.9132 6.05708 15.2319C6.41529 14.7497 6.78318 14.2594 7.16075 13.7528ZM13.6763 8.69459C13.6569 7.7712 13.899 7.21553 14.4411 6.75792C15.4189 5.92441 16.9292 5.99796 17.8199 6.91318C18.7396 7.85291 18.6138 9.34014 17.5198 10.141C16.8227 10.6558 16.0095 10.8029 15.1575 10.4678C14.141 10.0592 13.7053 9.33197 13.6763 8.69459ZM5.57302 8.39224C5.56333 7.86108 5.7376 7.37079 6.12485 6.95404C7.17043 5.82635 9.09702 5.94076 9.94897 7.19101C10.6073 8.15526 10.404 9.39735 9.44554 10.1164C8.73881 10.6476 7.9159 10.7947 7.04458 10.4515C6.02804 10.0511 5.59238 9.31563 5.57302 8.39224Z"
      fill="#C2C2C2"
    />
  </svg>
)

export const MirrorLight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="17"
    height="21"
    viewBox="0 0 17 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.927734 8.26888C0.927734 4.25439 4.18212 1 8.19662 1H8.65885C12.6733 1 15.9277 4.25439 15.9277 8.26888V19.2143H0.927734V8.26888Z"
      stroke="#C2C2C2"
      strokeWidth="1.60714"
    />
  </svg>
)

export const ArpeggiLogoDark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2167_37587)">
      <g filter="url(#filter0_i_2167_37587)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.70491 0H-0.000976562V20H5.88138V11.7647H4.70491V0Z"
          fill="#141414"
        />
      </g>
      <g filter="url(#filter1_i_2167_37587)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.05859 20V11.7647H8.23559V0H11.7646V11.7647H12.9409V20H7.05859Z"
          fill="#141414"
        />
      </g>
      <g filter="url(#filter2_i_2167_37587)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.1187 11.7647V20H20.001V0H15.2961V11.7647H14.1187Z"
          fill="#141414"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_i_2167_37587"
        x="-0.000976562"
        y="0"
        width="5.88232"
        height="22.3529"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2.35294" />
        <feGaussianBlur stdDeviation="1.76471" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2167_37587" />
      </filter>
      <filter
        id="filter1_i_2167_37587"
        x="7.05859"
        y="0"
        width="5.88232"
        height="22.3529"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2.35294" />
        <feGaussianBlur stdDeviation="1.76471" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2167_37587" />
      </filter>
      <filter
        id="filter2_i_2167_37587"
        x="14.1187"
        y="0"
        width="5.88232"
        height="22.3529"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2.35294" />
        <feGaussianBlur stdDeviation="1.76471" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2167_37587" />
      </filter>
      <clipPath id="clip0_2167_37587">
        <rect width="20" height="20" rx="1.56607" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const ArpeggiLogoLight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2167_37516)">
      <g filter="url(#filter0_i_2167_37516)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.70491 0H-0.000976562V20H5.88138V11.7647H4.70491V0Z"
          fill="white"
        />
      </g>
      <g filter="url(#filter1_i_2167_37516)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.05859 20V11.7647H8.23559V0H11.7646V11.7647H12.9409V20H7.05859Z"
          fill="white"
        />
      </g>
      <g filter="url(#filter2_i_2167_37516)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.1187 11.7647V20H20.001V0H15.2961V11.7647H14.1187Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_i_2167_37516"
        x="-0.000976562"
        y="0"
        width="5.88232"
        height="22.3529"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2.35294" />
        <feGaussianBlur stdDeviation="1.76471" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2167_37516" />
      </filter>
      <filter
        id="filter1_i_2167_37516"
        x="7.05859"
        y="0"
        width="5.88232"
        height="22.3529"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2.35294" />
        <feGaussianBlur stdDeviation="1.76471" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2167_37516" />
      </filter>
      <filter
        id="filter2_i_2167_37516"
        x="14.1187"
        y="0"
        width="5.88232"
        height="22.3529"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2.35294" />
        <feGaussianBlur stdDeviation="1.76471" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2167_37516" />
      </filter>
      <clipPath id="clip0_2167_37516">
        <rect width="20" height="20" rx="1.56607" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const ArpeggiLogoColor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_59_108)">
      <mask id="mask0_59_108" maskUnits="userSpaceOnUse" x="-1" y="0" width="34" height="33">
        <g clipPath="url(#clip1_59_108)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.75952 0.00134277H-0.00231934V32.9922H9.70089V19.4073H7.75952V0.00134277Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.6479 32.9909V19.4064H13.5893V0H19.4123V19.4064H21.3512V32.9909H11.6479Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.2874 19.4064V32.9909H32.9906V0H25.2311V19.4064H23.2874Z"
            fill="white"
          />
        </g>
      </mask>
      <g mask="url(#mask0_59_108)">
        <g filter="url(#filter0_f_59_108)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.51812 7.58354C16.4763 7.6508 31.0019 8.43266 34.5829 20.5474C38.1118 32.4858 26.2664 41.4169 16.6624 48.668C7.50784 55.5798 -3.38618 62.7092 -12.9311 56.4208C-24.4314 48.8443 -31.3439 33.6397 -26.5432 20.2035C-22.1959 8.03601 -7.73796 7.5146 4.51812 7.58354Z"
            fill="#E88D8D"
          />
        </g>
        <g filter="url(#filter1_f_59_108)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.2063 19.0384C22.3662 7.44738 21.9073 -6.67554 31.3559 -10.8951C40.6671 -15.0532 48.7157 -4.1283 55.2493 4.72871C61.4773 13.1713 51.8784 24.3008 47.5486 33.9386C42.3318 45.5506 12.3207 63.0818 1.18554 59.2617C-8.89823 55.8023 24.0673 30.9182 23.2063 19.0384Z"
            fill="#F6E08F"
          />
        </g>
        <g filter="url(#filter2_f_59_108)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.5058 -25.8536C24.8236 -25.7916 42.2153 -25.0709 46.503 -13.9043C50.7282 -2.90022 36.5454 5.33194 25.0464 12.0155C14.0854 18.3864 1.04176 24.9579 -10.3866 19.1617C-24.1562 12.1781 -32.4326 -1.83666 -26.6847 -14.2213C-21.4795 -25.4365 -4.16873 -25.9171 10.5058 -25.8536Z"
            fill="#A3DCD9"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_59_108"
        x="-43.0505"
        y="-7.38496"
        width="93.2344"
        height="81.1972"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="7.48188" result="effect1_foregroundBlur_59_108" />
      </filter>
      <filter
        id="filter1_f_59_108"
        x="-14.1089"
        y="-25.1807"
        width="84.7755"
        height="98.3512"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="6.68734" result="effect1_foregroundBlur_59_108" />
      </filter>
      <filter
        id="filter2_f_59_108"
        x="-42.5696"
        y="-39.8948"
        width="103.872"
        height="75.3308"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="7.0184" result="effect1_foregroundBlur_59_108" />
      </filter>
      <clipPath id="clip0_59_108">
        <rect width="32.9906" height="32.9906" fill="white" />
      </clipPath>
      <clipPath id="clip1_59_108">
        <rect x="-0.000244141" width="32.9909" height="32.9909" rx="2.5833" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const ArrowTopRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.6665 11.3333L11.3332 4.66663"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.6665 4.66663H11.3332V11.3333"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const Heart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="9" cy="9" r="9" fill="#5263F4" />
    <path
      d="M5.84842 12.1279H5.14258V11.4562H5.84842C6.53156 11.4562 7.15764 11.1488 7.56752 10.6024L8.10261 11.0122C7.56752 11.7181 6.73644 12.1279 5.8484 12.1279H5.84842ZM8.59218 6.73148L9.12727 7.14134C9.53713 6.60625 10.1633 6.31026 10.835 6.31026H12.1215L11.4612 6.97058L11.9394 7.44875L13.408 5.98014L11.9394 4.5L11.4612 4.97817L12.1215 5.63849H10.8236C9.94698 5.63849 9.12727 6.037 8.5922 6.73148H8.59218ZM11.9393 13.2664L13.408 11.7978L11.9393 10.3177L11.4612 10.7958L12.1215 11.4562H10.8236C9.63963 11.4562 8.67188 10.4884 8.67188 9.30441V8.35946C8.61493 6.85661 7.36265 5.64985 5.84842 5.64985H5.14258V6.32154H5.84842C7.03241 6.32154 8.00017 7.2893 8.00017 8.47329V9.41823C8.05711 10.9211 9.30939 12.1278 10.8236 12.1278L12.1215 12.1279L11.4612 12.7882L11.9393 13.2664Z"
      fill="white"
    />
    <circle cx="9" cy="9" r="9" fill="#E84AD8" />
    <g clipPath="url(#clip0_824_24769)">
      <path
        d="M11.947 6.53679C11.7768 6.36646 11.5746 6.23134 11.3521 6.13915C11.1297 6.04696 10.8912 5.99951 10.6504 5.99951C10.4095 5.99951 10.1711 6.04696 9.94858 6.13915C9.72609 6.23134 9.52395 6.36646 9.3537 6.53679L9.00037 6.89012L8.64703 6.53679C8.30313 6.19289 7.83671 5.99969 7.35037 5.99969C6.86402 5.99969 6.3976 6.19289 6.0537 6.53679C5.7098 6.88068 5.5166 7.34711 5.5166 7.83345C5.5166 8.3198 5.7098 8.78622 6.0537 9.13012L6.40703 9.48345L9.00037 12.0768L11.5937 9.48345L11.947 9.13012C12.1174 8.95987 12.2525 8.75772 12.3447 8.53524C12.4369 8.31275 12.4843 8.07428 12.4843 7.83345C12.4843 7.59262 12.4369 7.35415 12.3447 7.13167C12.2525 6.90918 12.1174 6.70704 11.947 6.53679Z"
        fill="white"
        stroke="white"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_824_24769">
        <rect width="8" height="8" fill="white" transform="translate(5 5)" />
      </clipPath>
    </defs>
  </svg>
)

export const Share = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="9" cy="9" r="9" fill="#5263F4" />
    <path
      d="M5.84842 12.1279H5.14258V11.4562H5.84842C6.53156 11.4562 7.15764 11.1488 7.56752 10.6024L8.10261 11.0122C7.56752 11.7181 6.73644 12.1279 5.8484 12.1279H5.84842ZM8.59218 6.73148L9.12727 7.14134C9.53713 6.60625 10.1633 6.31026 10.835 6.31026H12.1215L11.4612 6.97058L11.9394 7.44875L13.408 5.98014L11.9394 4.5L11.4612 4.97817L12.1215 5.63849H10.8236C9.94698 5.63849 9.12727 6.037 8.5922 6.73148H8.59218ZM11.9393 13.2664L13.408 11.7978L11.9393 10.3177L11.4612 10.7958L12.1215 11.4562H10.8236C9.63963 11.4562 8.67188 10.4884 8.67188 9.30441V8.35946C8.61493 6.85661 7.36265 5.64985 5.84842 5.64985H5.14258V6.32154H5.84842C7.03241 6.32154 8.00017 7.2893 8.00017 8.47329V9.41823C8.05711 10.9211 9.30939 12.1278 10.8236 12.1278L12.1215 12.1279L11.4612 12.7882L11.9393 13.2664Z"
      fill="white"
    />
  </svg>
)

export const Bell = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.25 6.33331C14.25 5.07353 13.7496 3.86535 12.8588 2.97456C11.968 2.08376 10.7598 1.58331 9.5 1.58331C8.24022 1.58331 7.03204 2.08376 6.14124 2.97456C5.25045 3.86535 4.75 5.07353 4.75 6.33331C4.75 11.875 2.375 13.4583 2.375 13.4583H16.625C16.625 13.4583 14.25 11.875 14.25 6.33331Z"
      fill="inherit"
      stroke="currentColor"
      strokeWidth="1.58333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.8696 16.625C10.7304 16.8649 10.5306 17.0641 10.2903 17.2025C10.0499 17.341 9.7774 17.4139 9.50002 17.4139C9.22263 17.4139 8.95012 17.341 8.70975 17.2025C8.46939 17.0641 8.26962 16.8649 8.13043 16.625"
      stroke="currentColor"
      strokeWidth="1.58333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const CheckboxGreen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10" cy="10" r="10" fill="#5EC271" />
    <path
      d="M7 11.1818L8.90909 13.0909L14 8"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const Bug = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00004 1.5C6.61931 1.5 5.50002 2.61929 5.50002 4V4.25777C4.86424 4.68335 4.34296 5.26665 3.99216 5.95169L3.29084 5.25037C2.9281 4.88764 2.80664 4.76163 2.72106 4.62199C2.63882 4.48778 2.57822 4.34146 2.54147 4.18841C2.50324 4.02916 2.50002 3.85417 2.50002 3.34118V2.66667C2.50002 2.39053 2.27616 2.16667 2.00002 2.16667C1.72388 2.16667 1.50002 2.39053 1.50002 2.66667V3.34118L1.50001 3.39816C1.49989 3.83253 1.4998 4.1332 1.5691 4.42185C1.63034 4.67695 1.73135 4.92081 1.86842 5.14449C2.02353 5.39759 2.2362 5.61014 2.54343 5.91719L2.58373 5.95748L3.61427 6.988C3.53952 7.31327 3.50002 7.65207 3.50002 8V10C3.50002 10.1479 3.50716 10.2942 3.52111 10.4385L2.58373 11.3759L2.54344 11.4161C2.2362 11.7232 2.02353 11.9357 1.86842 12.1889C1.73135 12.4125 1.63034 12.6564 1.5691 12.9115C1.4998 13.2001 1.49989 13.5008 1.50001 13.9352L1.50002 13.9921V14.6667C1.50002 14.9428 1.72388 15.1667 2.00002 15.1667C2.27616 15.1667 2.50002 14.9428 2.50002 14.6667V13.9921C2.50002 13.4792 2.50324 13.3042 2.54147 13.1449C2.57822 12.9919 2.63882 12.8455 2.72106 12.7113C2.80664 12.5717 2.9281 12.4457 3.29084 12.0829L3.78756 11.5863C4.429 13.2888 6.07307 14.5 8.00004 14.5C9.92698 14.5 11.571 13.2888 12.2125 11.5863L12.7092 12.0829C13.072 12.4457 13.1934 12.5717 13.279 12.7113C13.3612 12.8455 13.4218 12.9919 13.4586 13.1449C13.4968 13.3042 13.5 13.4792 13.5 13.9921V14.6667C13.5 14.9428 13.7239 15.1667 14 15.1667C14.2762 15.1667 14.5 14.9428 14.5 14.6667V13.9921V13.9352C14.5002 13.5009 14.5002 13.2001 14.431 12.9115C14.3697 12.6564 14.2687 12.4125 14.1316 12.1889C13.9765 11.9357 13.7638 11.7232 13.4566 11.4161L13.4163 11.3759L12.4789 10.4385C12.4929 10.2942 12.5 10.1479 12.5 10V8C12.5 7.65207 12.4605 7.31327 12.3858 6.988L13.4163 5.95748L13.4566 5.9172C13.7638 5.61014 13.9765 5.39759 14.1316 5.14449C14.2687 4.92081 14.3697 4.67695 14.431 4.42185C14.5002 4.13321 14.5002 3.83255 14.5 3.39819V3.34118V2.66667C14.5 2.39053 14.2762 2.16667 14 2.16667C13.7239 2.16667 13.5 2.39053 13.5 2.66667V3.34118C13.5 3.85417 13.4968 4.02916 13.4586 4.18841C13.4218 4.34146 13.3612 4.48778 13.279 4.62199C13.1934 4.76163 13.072 4.88764 12.7092 5.25037L12.0079 5.95169C11.6571 5.26665 11.1358 4.68335 10.5 4.25777V4C10.5 2.61929 9.38071 1.5 8.00004 1.5ZM9.47904 3.74871C9.35951 3.03992 8.74284 2.5 8.00004 2.5C7.25724 2.5 6.64053 3.03992 6.52098 3.74871C6.98424 3.58757 7.48191 3.5 8.00004 3.5C8.51818 3.5 9.01584 3.58757 9.47904 3.74871ZM8.50004 10V13.4645C10.1962 13.2219 11.5 11.7633 11.5 10V8C11.5 6.06701 9.93304 4.5 8.00004 4.5C6.06703 4.5 4.50002 6.067 4.50002 8V10C4.50002 11.7633 5.80388 13.2219 7.50004 13.4645V10C7.50004 9.72387 7.72391 9.5 8.00004 9.5C8.27618 9.5 8.50004 9.72387 8.50004 10Z"
      fill="currentColor"
    />
  </svg>
)

export const ArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="8"
    height="12"
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.86081 0.329574C7.25744 0.7262 7.25744 1.36926 6.86081 1.76588L2.62674 5.99996L6.86081 10.234C7.25744 10.6307 7.25744 11.2737 6.86081 11.6703C6.46419 12.067 5.82113 12.067 5.4245 11.6703L0.472274 6.71811C0.0756482 6.32149 0.0756482 5.67843 0.472274 5.2818L5.4245 0.329574C5.82113 -0.067052 6.46419 -0.0670521 6.86081 0.329574Z"
      fill="#141414"
    />
  </svg>
)

export const ShareDarkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18 8C19.6569 8 21 6.65685 21 5C21 3.34315 19.6569 2 18 2C16.3431 2 15 3.34315 15 5C15 6.65685 16.3431 8 18 8Z"
      stroke="#141414"
      strokeOpacity="0.8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 15C7.65685 15 9 13.6569 9 12C9 10.3431 7.65685 9 6 9C4.34315 9 3 10.3431 3 12C3 13.6569 4.34315 15 6 15Z"
      stroke="#141414"
      strokeOpacity="0.8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 22C19.6569 22 21 20.6569 21 19C21 17.3431 19.6569 16 18 16C16.3431 16 15 17.3431 15 19C15 20.6569 16.3431 22 18 22Z"
      stroke="#141414"
      strokeOpacity="0.8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.59009 13.51L15.4201 17.49"
      stroke="#141414"
      strokeOpacity="0.8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4101 6.51001L8.59009 10.49"
      stroke="#141414"
      strokeOpacity="0.8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const SoundCloudIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.00001 11.9998H4.99999V5.70274C4.62498 5.80874 4.28698 6.00124 4.00001 6.25421C4.00001 6.25427 4.00001 11.9998 4.00001 11.9998ZM2.00001 7.73976V11.9927L2.06449 11.9997H2.99998V7.73322H2.06449C2.06449 7.73328 2.00001 7.73976 2.00001 7.73976ZM0 9.86576C0 10.6403 0.403022 11.3118 0.999976 11.6863V8.04727C0.403022 8.42124 0 9.09278 0 9.86576ZM6.00002 11.9998H7V5.98026C6.701 5.79374 6.36251 5.67077 6.00002 5.62326V11.9998ZM13.9355 7.73328H13.373C13.4015 7.55928 13.4195 7.38276 13.4195 7.20026C13.4195 5.43274 12.033 4.00024 10.3225 4.00024C9.39457 4.00024 8.56754 4.42727 8.00003 5.09622V11.9997H13.9355C15.075 11.9997 16 11.0447 16 9.8657C16 8.68778 15.075 7.73328 13.9355 7.73328Z"
      fill="currentColor"
    />
  </svg>
)

export const AlertIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M7.99984 1.84782C4.31794 1.84782 1.33317 4.83259 1.33317 8.51449C1.33317 12.1964 4.31794 15.1812 7.99984 15.1812C11.6817 15.1812 14.6665 12.1964 14.6665 8.51449C14.6665 4.83259 11.6817 1.84782 7.99984 1.84782Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 5.84798V8.51465"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 11.1812H7.99333"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
